/* tencho36-material-sale-redirect-20260714 */
(function () {
  var sourcePath = "/collections/tencho36-summer-sale";
  var targetPath = "/collections/material";
  var location = window.location;
  if (!location || location.pathname.replace(/\/+$/, "") !== sourcePath) return;

  location.replace(targetPath + location.search + location.hash);
})();

/* wrinkle-comparison-native-video-fallback-20260721-v1 */
(function () {
  'use strict';

  var targetPath = '/blogs/journal/cotton-poly-dungaree-light-weather-wrinkle-comparison';
  if (window.location.pathname !== targetPath) return;

  var marker = 'wrinkle-comparison-native-video-20260721-v1';
  var lv4Url = 'https://cdn.shopify.com/videos/c/o/v/efa18ff88da448c49caaaada264e16ad.mp4';
  var lv5Url = 'https://cdn.shopify.com/videos/c/o/v/7156263fb3e14aa08c99e1e6b69b4728.mp4';
  var oldVideoTokens = [
    'b8261a2e590145f5a07f5f01e35e464c',
    'c6f6120784a14651ac1d7afd15ad50e9'
  ];

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, '').trim();
  }

  function isEmptyParagraph(node) {
    if (!node || node.nodeType !== 1 || node.tagName !== 'P') return false;
    return cleanText(node.textContent).replace(/\u00a0/g, '') === '';
  }

  function findHeading(prose, text) {
    var headings = prose.querySelectorAll('h2');
    var target = cleanText(text);
    for (var i = 0; i < headings.length; i += 1) {
      if (cleanText(headings[i].textContent) === target) return headings[i];
    }
    return null;
  }

  function makeVideoFigure(level, url, caption, label) {
    var figure = document.createElement('figure');
    figure.className = 'maruishi-article-video maruishi-article-video--wrinkle-lv' + level;
    figure.setAttribute('data-marker', marker + '-lv' + level);
    figure.style.margin = '16px 0 28px';
    figure.innerHTML = [
      '<video src="' + url + '" controls playsinline preload="metadata" style="display:block;width:100%;max-width:720px;height:auto;margin:0 auto;border-radius:8px;background:#000;" aria-label="' + label + '">',
      '動画を再生できない場合は、商品ページをご確認ください。',
      '</video>',
      '<figcaption style="font-size:14px;line-height:1.7;color:#666;margin-top:8px;">' + caption + '</figcaption>'
    ].join('');
    return figure;
  }

  function removeExistingVideoBlocks(prose) {
    prose.querySelectorAll('[data-marker^="' + marker + '"], .maruishi-article-video--wrinkle-lv4, .maruishi-article-video--wrinkle-lv5').forEach(function (node) {
      node.remove();
    });

    prose.querySelectorAll('video').forEach(function (video) {
      var src = video.getAttribute('src') || '';
      var source = video.querySelector('source');
      var sourceSrc = source ? source.getAttribute('src') || '' : '';
      var combined = src + ' ' + sourceSrc;
      var isTargetVideo = combined.indexOf(lv4Url) !== -1 || combined.indexOf(lv5Url) !== -1;
      oldVideoTokens.forEach(function (token) {
        if (combined.indexOf(token) !== -1) isTargetVideo = true;
      });
      if (isTargetVideo) {
        var figure = video.closest('figure');
        (figure || video).remove();
      }
    });
  }

  function removeInstagramEmbeds(prose) {
    prose.querySelectorAll('blockquote.instagram-media, script[src*="instagram.com/embed.js"]').forEach(function (node) {
      node.remove();
    });
  }

  function insertAfterHeading(heading, figure) {
    var next = heading.nextSibling;
    while (next && isEmptyParagraph(next)) {
      var empty = next;
      next = next.nextSibling;
      empty.remove();
    }
    heading.parentNode.insertBefore(figure, next);
  }

  function applyFallback() {
    var prose = document.querySelector('.article__wrapper .prose');
    if (!prose) return;

    var lv4Heading = findHeading(prose, 'シワへの強さLv4動画');
    var lv5Heading = findHeading(prose, 'シワへの強さLv5動画');
    if (!lv4Heading || !lv5Heading) return;

    removeExistingVideoBlocks(prose);
    removeInstagramEmbeds(prose);

    insertAfterHeading(
      lv4Heading,
      makeVideoFigure('4', lv4Url, 'シワへの強さLv4の綿ポリダンガリーシリーズ', 'シワへの強さLv4の綿ポリダンガリー動画')
    );
    insertAfterHeading(
      lv5Heading,
      makeVideoFigure('5', lv5Url, 'シワへの強さLv5の綿ポリライトウェザーシリーズ', 'シワへの強さLv5の綿ポリライトウェザー動画')
    );

    if (document.documentElement.innerHTML.indexOf(marker) === -1) {
      document.documentElement.setAttribute('data-wrinkle-video-fallback', marker);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFallback, { once: true });
  } else {
    applyFallback();
  }
})();

/* thread-quick-add-position-runtime-20260721 */
(function () {
  var initializedAttr = 'threadQuickAddInitialized';

  function getRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('thread-quick-add'));
  }

  function moveIntoBuyButtons() {
    var buyBlock = document.querySelector('[data-block-type="buy-buttons"]');
    if (!buyBlock) return;

    var roots = getRoots();
    if (!roots.length) return;

    var rootInBuyBlock = roots.find(function (root) {
      return buyBlock.contains(root);
    });
    var root = rootInBuyBlock || roots[0];
    var buyButtons = buyBlock.querySelector('buy-buttons');

    if (buyButtons && !buyBlock.contains(root)) {
      buyButtons.insertAdjacentElement('afterend', root);
    }

    getRoots().forEach(function (candidate) {
      if (candidate !== root) candidate.remove();
    });
  }

  function parseVariants(root) {
    var script = root.querySelector('[data-thread-quick-add-variants]');
    try {
      return JSON.parse(script ? script.textContent : '{}');
    } catch (_) {
      return {};
    }
  }

  function selectedVariantId(root, form) {
    if (form && form.elements && form.elements.id && form.elements.id.value) {
      return String(form.elements.id.value);
    }
    return String(root.getAttribute('data-selected-variant-id') || '');
  }

  function setStatus(root, statusEl, message, isError) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.hidden = !message;
    root.classList.toggle('is-error', Boolean(isError));
  }

  function updateSelected(root, form, variants, currentEl, statusEl, button, variant) {
    var id = variant && variant.id ? String(variant.id) : selectedVariantId(root, form);
    var item = variants[id];
    var fallback = root.getAttribute('data-default-label') || '';

    root.setAttribute('data-selected-variant-id', id);
    if (currentEl) currentEl.textContent = item && item.label ? item.label : fallback;

    if (!button) return;
    if (item && item.available === false) {
      button.disabled = true;
      setStatus(root, statusEl, '選択中の生地は在庫切れです。', false);
    } else if (button.getAttribute('aria-busy') !== 'true') {
      button.disabled = false;
      setStatus(root, statusEl, '', false);
    }
  }

  function initThreadQuickAdd(root) {
    if (!root || root.dataset[initializedAttr] === 'true' || root.dataset.initialized === 'true') return;

    var formId = root.getAttribute('data-product-form-id');
    var form = document.forms[formId] || document.getElementById(formId);
    if (!form) return;

    root.dataset[initializedAttr] = 'true';

    var variants = parseVariants(root);
    var currentEl = root.querySelector('[data-thread-quick-add-current]');
    var statusEl = root.querySelector('[data-thread-quick-add-status]');
    var button = root.querySelector('[data-thread-quick-add-button]');
    var threadVariantId = root.getAttribute('data-thread-variant-id');
    var threadQuantity = parseInt(root.getAttribute('data-thread-quantity') || '1', 10) || 1;
    var busy = false;

    async function addThread() {
      if (busy || !threadVariantId || !button) return;

      var item = variants[selectedVariantId(root, form)];
      var fabricLabel = item && item.label ? item.label : (currentEl ? currentEl.textContent.trim() : root.getAttribute('data-default-label') || '');
      if (!fabricLabel) {
        setStatus(root, statusEl, '選択中のカラーを取得できませんでした。', true);
        return;
      }

      busy = true;
      var previousText = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = '追加中...';
      setStatus(root, statusEl, '', false);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        var shopRoot = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        var response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{
              id: Number(threadVariantId),
              quantity: threadQuantity,
              properties: { '合わせ生地': fabricLabel }
            }],
            sections: sectionsToBundle,
            sections_url: shopRoot + 'variants/' + threadVariantId
          })
        });
        var responseJson = await response.json();

        if (!response.ok) {
          throw new Error(responseJson.description || responseJson.message || '商品を追加できませんでした。');
        }

        if (window.themeVariables && window.themeVariables.settings && (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')) {
          window.location.href = shopRoot + 'cart';
          return;
        }

        var cartContent = await (await fetch(shopRoot + 'cart.js')).json();
        cartContent.sections = responseJson.sections || {};

        var detail = {
          items: responseJson.items || [responseJson],
          cart: cartContent,
          onSuccessDo: 'force_open_drawer'
        };
        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: detail }));

        if (cartContent.sections && Object.keys(cartContent.sections).length > 0) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              onSuccessDo: 'force_open_drawer',
              cart: cartContent
            }
          }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }

        button.textContent = '追加しました';
        setTimeout(function () {
          button.textContent = previousText;
          updateSelected(root, form, variants, currentEl, statusEl, button);
        }, 1400);
      } catch (error) {
        button.textContent = previousText;
        setStatus(root, statusEl, error.message || '商品を追加できませんでした。', true);
        button.disabled = false;
      } finally {
        busy = false;
        button.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    form.addEventListener('variant:change', function (event) {
      updateSelected(root, form, variants, currentEl, statusEl, button, event.detail && event.detail.variant);
      setTimeout(run, 0);
    });

    if (form.elements && form.elements.id) {
      form.elements.id.addEventListener('change', function () {
        updateSelected(root, form, variants, currentEl, statusEl, button);
      });
    }

    if (button) button.addEventListener('click', addThread);
    updateSelected(root, form, variants, currentEl, statusEl, button);
  }

  function run() {
    moveIntoBuyButtons();
    getRoots().forEach(initThreadQuickAdd);
  }

  window.MaruishiThreadQuickAdd = window.MaruishiThreadQuickAdd || {};
  window.MaruishiThreadQuickAdd.init = initThreadQuickAdd;
  window.MaruishiThreadQuickAdd.run = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('pageshow', run);

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
          return node.nodeType === 1 && (node.matches && node.matches('thread-quick-add') || node.querySelector && node.querySelector('thread-quick-add'));
        });
      })) {
        run();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* payment-image-near-cart-runtime-20260803 */
(function () {
  var markerAttr = 'paymentImageNearCartMoved';

  function paymentImageBlock() {
    var byId = document.querySelector('.product-info__block-item[data-block-id="image_MB9RDg"][data-block-type="image"]');
    if (byId) return byId;

    var image = document.querySelector('.product-info__block-item[data-block-type="image"] img[src*="payment-cart-bottom.png"]');
    return image ? image.closest('.product-info__block-item') : null;
  }

  function movePaymentImageNearCart() {
    var buyBlock = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    if (!buyBlock || buyBlock.dataset[markerAttr] === 'true') return;

    if (buyBlock.querySelector('[data-payment-image-near-cart]')) {
      buyBlock.dataset[markerAttr] = 'true';
      return;
    }

    var block = paymentImageBlock();
    if (!block || buyBlock.contains(block)) return;

    var productForm = buyBlock.querySelector('product-form');
    var anchor = productForm || buyBlock.querySelector('buy-buttons');
    if (!anchor) return;

    block.classList.add('product-info__payment-image-near-cart');
    block.setAttribute('data-payment-image-near-cart', '');
    block.setAttribute('data-moved-by', 'custom-js-20260803');
    block.style.marginBlockStart = '6px';

    var image = block.querySelector('img');
    if (image) image.style.display = 'block';

    anchor.insertAdjacentElement('afterend', block);
    buyBlock.dataset[markerAttr] = 'true';
  }

  function run() {
    movePaymentImageNearCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('pageshow', run);

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
          return node.nodeType === 1 && (
            node.matches && node.matches('.product-info__block-item[data-block-type="image"], .product-info__block-item[data-block-type="buy-buttons"]') ||
            node.querySelector && node.querySelector('.product-info__block-item[data-block-type="image"], .product-info__block-item[data-block-type="buy-buttons"]')
          );
        });
      })) {
        run();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* tencho36-announcement-link-20260718 */
(function () {
  var targetPath = "/collections/material";
  var marker = "tencho36-announcement-link-20260718";

  function ensureStyle() {
    if (document.getElementById(marker)) return;
    var style = document.createElement("style");
    style.id = marker;
    style.textContent = ".announcement-bar__message-link{color:inherit;text-decoration:none;cursor:pointer}.announcement-bar__message-link:hover{text-decoration:underline;text-underline-offset:.18em}";
    (document.head || document.documentElement).appendChild(style);
  }

  function linkSaleAnnouncement() {
    var messages = document.querySelectorAll(".announcement-bar__carousel > .prose, .announcement-bar__carousel > p, .announcement-bar__carousel > a");
    messages.forEach(function (message) {
      var text = message.textContent || "";
      if (text.indexOf("店長36歳") === -1 || text.indexOf("10%OFF") === -1) return;

      if (message.tagName === "A") {
        message.setAttribute("href", targetPath);
        message.classList.add("announcement-bar__message-link");
        return;
      }

      var link = document.createElement("a");
      Array.prototype.slice.call(message.attributes || []).forEach(function (attribute) {
        if (attribute.name !== "class") link.setAttribute(attribute.name, attribute.value);
      });
      link.href = targetPath;
      link.className = (message.className ? message.className + " " : "") + "announcement-bar__message-link";
      link.innerHTML = message.innerHTML;
      message.replaceWith(link);
    });
  }

  function run() {
    ensureStyle();
    linkSaleAnnouncement();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();

/* 7450-baby-video-cache-fallback-20260714 */
(function () {
  var marker = '7450-knit-baby-video-20260714-v1';
  var videoUrl = 'https://cdn.shopify.com/videos/c/vp/fb3dec9245af4c52b2ebf6dbc38c4bd6/fb3dec9245af4c52b2ebf6dbc38c4bd6.SD-480p-1.5Mbps-88912773.mp4';
  var posterUrl = 'https://cdn.shopify.com/s/files/1/0944/6821/0981/files/7450-knit-baby-video-poster-20260714.jpg?v=1784030273&width=720';

  function isTargetPage() {
    return window.location && window.location.pathname.replace(/\/+$/, '') === '/products/7450';
  }

  function blockHtml() {
    return [
      '<!-- ' + marker + ' -->',
      '<section class="' + marker + '" style="margin:2rem 0;padding:18px;border:1px solid #e6ded6;background:#faf7f2;border-radius:8px;">',
      '  <h2 style="margin:0 0 10px;">ベビー服にも使いやすい、やわらかい国産ニット</h2>',
      '  <p style="margin:0 0 14px;">7450フライスニットをベビー服に使った時の、やわらかい雰囲気を動画で確認できます。</p>',
      '  <video src="' + videoUrl + '" controls playsinline preload="metadata" poster="' + posterUrl + '" style="display:block;width:100%;max-width:420px;aspect-ratio:9/16;object-fit:cover;border-radius:8px;background:#000;margin:0 auto;">',
      '    動画を再生できない場合は、ページ内の画像と商品説明をご確認ください。',
      '  </video>',
      '  <p style="margin:14px 0 0;">コットン100%で、Tシャツやベビー肌着、子ども服にも使いやすいフライスニットです。ベビー基準検査済の生地なので、肌ざわりを重視したい作品にも選びやすいです。</p>',
      '</section>',
      '<!-- /' + marker + ' -->'
    ].join('\n');
  }

  function insertBabyVideoFallback() {
    if (!isTargetPage()) return;
    if (document.documentElement.innerHTML.indexOf(marker) !== -1 || document.querySelector('video[src="' + videoUrl + '"]')) return;

    var dogwearBlock = document.querySelector('.dogwear-7450-milk-3255-yellow-product-work-20260610-v1');
    if (dogwearBlock) {
      dogwearBlock.insertAdjacentHTML('beforebegin', blockHtml());
      return;
    }

    var container = document.querySelector('.product-content-below-gallery__description.prose, .accordion__content.prose');
    if (container) container.insertAdjacentHTML('afterbegin', blockHtml());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertBabyVideoFallback);
  } else {
    insertBabyVideoFallback();
  }
})();

/* catalog-canonical-view-redirect-20260710 */
(function () {
  var targetPath = "/products/maruishi-catalog";
  var targetView = "catalog-main-fabric-routes-20260710";
  var location = window.location;
  if (!location || location.pathname !== targetPath) return;

  var url = new URL(location.href);
  if (url.searchParams.get("view") === targetView) return;
  url.searchParams.set("view", targetView);
  location.replace(url.toString());
})();

// cart-pattern-popup-disabled-20260710: remove cart pattern popup markup from stale Shopify full-page cache.
(function () {
  function removeRevertedCartPatternPopup() {
    try {
      sessionStorage.setItem('katagami_popup_dismissed', '1');
    } catch (_) {}

    if (window.location.pathname.replace(/\/+$/, '') !== '/cart') return;

    document.querySelectorAll('.katagami-popup').forEach(function (popup) {
      popup.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeRevertedCartPatternPopup, { once: true });
  } else {
    removeRevertedCartPatternPopup();
  }

  window.addEventListener('pageshow', removeRevertedCartPatternPopup);
})();

/* product-card-swatch-hotfix-20260611 */
(function () {
  var marker = "product-card-swatch-hotfix-20260611";
  if (document.getElementById(marker)) return;
  var style = document.createElement("style");
  style.id = marker;
  style.textContent = ":root{--product-card-swatch-hotfix-20260611:1}.product-card__image-container{display:none}.product-card__color-swatches{display:flex;align-items:center;justify-content:flex-start;gap:4px;width:100%;max-width:100%;min-width:0;min-height:30px;margin-top:2px;overflow:hidden}.product-card__color-swatches:empty{display:none}.product-card__color-swatch-viewport{flex:1 1 auto;min-width:0;max-width:100%;overflow:hidden}.product-card__color-swatch-list{display:flex;align-items:center;justify-content:flex-start;gap:8px;flex-wrap:nowrap;max-width:100%;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;scroll-snap-type:x proximity;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding:4px 2px 6px;margin:-4px -2px -6px}.product-card__color-swatch-list::-webkit-scrollbar{display:none}.product-card__color-swatch{flex:0 0 28px;display:grid;place-items:center;width:28px;height:28px;padding:2px;border:1px solid #D2C9C0;border-radius:5px;background:#fff center/cover no-repeat;box-shadow:0 4px 10px rgba(63,58,57,.12);overflow:hidden;cursor:pointer;scroll-snap-align:start;transition:border-color .16s ease,box-shadow .16s ease,transform .16s ease}.product-card__color-swatch:hover,.product-card__color-swatch.is-selected,.product-card__color-swatch[aria-current=true]{border-color:#3F3A39;box-shadow:0 6px 14px rgba(63,58,57,.18);transform:translateY(-1px)}.product-card__color-swatch img{display:block;width:100%;height:100%;border-radius:3px;object-fit:cover}.product-card__color-swatch-next{display:none;flex:0 0 auto;align-items:center;justify-content:center;width:24px;height:28px;padding:0;border:0;border-radius:999px;background:transparent;color:var(--base-bk,#3F3A39);cursor:pointer}.product-card__color-swatches.is-scrollable .product-card__color-swatch-next{display:inline-flex}.product-card__color-swatch-next:hover{color:#111}.product-card__color-swatch-next svg{width:14px;height:auto}.product-card__color-count{letter-spacing:0;white-space:nowrap}";
  (document.head || document.documentElement).appendChild(style);
})();

/* school-invoice-copy-fix-20260616 */
(function () {
  function updateSchoolInvoiceCopy() {
    if (window.location.pathname !== '/pages/school-public-invoice-payment') return;

    var page = document.querySelector('[data-school-invoice-payment-page]');
    if (!page) return;

    var headings = page.querySelectorAll('.sip-section-head');
    headings.forEach(function (heading) {
      var title = heading.querySelector('.sip-title');
      if (!title || title.textContent.trim() !== '学校で使いやすい入口') return;

      var kicker = heading.querySelector('.sip-kicker');
      var lead = heading.querySelector('p:not(.sip-kicker)');
      if (kicker) kicker.textContent = '商品選びの参考に';
      title.textContent = '学校教材・製作販売で使いやすい生地';
      if (lead) {
        lead.textContent = 'お見積りをご希望の場合は、候補の商品ページURLと必要数量をお知らせください。まだ商品が決まっていない場合は、作るものや用途から一緒に確認します。';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSchoolInvoiceCopy);
  } else {
    updateSchoolInvoiceCopy();
  }
})();

// gallery-form-id-fix-20260908-v1
// maruishi-product-gallery-sync-20260729-v1
// 色別 gallery 並び替えと、メイン画像・サムネイル・ドットの同期を1箇所に集約。
(function () {
  var COLOR_TAG_PREFIXES = ['#カラー_', '#色_', '#Color_'];
  var TAG_STOP_PREFIXES = COLOR_TAG_PREFIXES.concat(['#柄の大きさ_', '#サイズ_', '#Size_']);
  var queuedFrames = new WeakMap();
  var syncedGalleryVariants = new WeakMap();
  var queuedVariants = new WeakMap();
  var boundForms = new WeakMap();
  var latestVariantsByFormId = {};

  function selectorEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function formForGallery(gallery) {
    var formId = gallery.getAttribute('form');
    if (!formId) return null;
    return document.getElementById(formId) || document.forms[formId] || document.forms.namedItem(formId);
  }

  function formIdForGallery(gallery) {
    return gallery.getAttribute('form') || '';
  }

  function galleriesForFormId(formId) {
    if (!formId) return Array.from(document.querySelectorAll('product-gallery'));
    return Array.from(document.querySelectorAll('product-gallery[form="' + selectorEscape(formId) + '"]'));
  }

  function pickerForGallery(gallery) {
    var formId = gallery.getAttribute('form');
    return formId ? document.querySelector('variant-picker[form-id="' + selectorEscape(formId) + '"]') : null;
  }

  function variantFromPicker(picker) {
    var script = picker && picker.querySelector('script[data-variant]');
    if (!script) return null;

    try {
      var variant = JSON.parse(script.textContent || '{}');
      return variant && variant.id ? variant : null;
    } catch (error) {
      return null;
    }
  }

  function mediaIdFromVariant(variant) {
    if (!variant) return null;
    var media = variant.featured_media || variant.featuredMedia || variant.featured_image || variant.image;
    return media && media.id ? String(media.id) : null;
  }

  function selectedVariantForGallery(gallery, eventVariant) {
    if (eventVariant && mediaIdFromVariant(eventVariant)) return eventVariant;
    var latestVariant = latestVariantsByFormId[formIdForGallery(gallery)];
    if (latestVariant && mediaIdFromVariant(latestVariant)) return latestVariant;
    return variantFromPicker(pickerForGallery(gallery));
  }

  function rememberVariant(formId, variant) {
    if (formId && variant && mediaIdFromVariant(variant)) {
      latestVariantsByFormId[formId] = variant;
    }
  }

  function parseColor(alt) {
    var text = String(alt || '');
    var match = COLOR_TAG_PREFIXES.reduce(function (best, prefix) {
      var index = text.indexOf(prefix);
      if (index === -1) return best;
      return !best || index < best.index ? { index: index, prefix: prefix } : best;
    }, null);

    if (!match) return '';

    var valueStart = match.index + match.prefix.length;
    var valueEnd = text.length;
    TAG_STOP_PREFIXES.forEach(function (prefix) {
      var nextIndex = text.indexOf(prefix, valueStart);
      if (nextIndex !== -1 && nextIndex < valueEnd) valueEnd = nextIndex;
    });

    return normalize(text.slice(valueStart, valueEnd));
  }

  function colorFromVariant(variant) {
    if (!variant) return '';
    var options = Array.isArray(variant.options) ? variant.options.slice() : [];
    if (!options.length) {
      [variant.option1, variant.option2, variant.option3].forEach(function (option) {
        if (option) options.push(option);
      });
    }

    for (var index = options.length - 1; index >= 0; index -= 1) {
      var value = normalize(options[index]);
      if (!value) continue;
      if (/^\d+(\.\d+)?\s*mm$/.test(value)) continue;
      if (/^\d+(\.\d+)?\s*cm$/.test(value)) continue;
      if (/^\d+\s*号$/.test(value)) continue;
      return value;
    }

    return normalize(variant.public_title || variant.title || '');
  }
  function mediaAlt(media) {
    var image = media.querySelector('img');
    return image ? image.getAttribute('alt') || '' : '';
  }

  function isSharedColor(color) {
    return !color || color === '共通';
  }

  function sameOrder(current, ordered) {
    return current.length === ordered.length && current.every(function (element, index) {
      return element === ordered[index];
    });
  }

  function clearThemeFiltering(gallery, carousel) {
    if (gallery.getAttribute('filtered-indexes') !== '[]') {
      gallery.setAttribute('filtered-indexes', '[]');
    }

    if (carousel && typeof carousel.filter === 'function') {
      carousel.filter([]);
      return;
    }

    gallery.querySelectorAll('.product-gallery__media[hidden], .product-gallery__thumbnail[hidden], .page-dots button[hidden]').forEach(function (element) {
      element.removeAttribute('hidden');
    });
  }

  function sortMedia(mediaEls, featuredMediaId, selectedColor) {
    return mediaEls.map(function (element, index) {
      var mediaId = element.dataset.mediaId || '';
      var color = parseColor(mediaAlt(element));
      var group = 3;

      if (mediaId === featuredMediaId) {
        group = 0;
      } else if (selectedColor && color === selectedColor) {
        group = 1;
      } else if (isSharedColor(color)) {
        group = 2;
      }

      return { element: element, index: index, group: group };
    }).sort(function (a, b) {
      return a.group - b.group || a.index - b.index;
    }).map(function (item) {
      return item.element;
    });
  }

  function mediaIdList(elements) {
    return elements.map(function (element) {
      return element.dataset.mediaId || '';
    });
  }

  function thumbnailMap(gallery) {
    var map = {};
    gallery.querySelectorAll('.product-gallery__thumbnail[data-media-id]').forEach(function (thumbnail) {
      map[thumbnail.dataset.mediaId] = thumbnail;
    });
    return map;
  }

  function updatePositions(orderedMedia, gallery) {
    var thumbs = thumbnailMap(gallery);
    orderedMedia.forEach(function (media, index) {
      var mediaId = media.dataset.mediaId || '';
      media.dataset.mediaPosition = String(index + 1);
      media.setAttribute('aria-label', 'Item ' + (index + 1) + ' of ' + orderedMedia.length);

      var thumb = thumbs[mediaId];
      if (thumb) {
        thumb.dataset.mediaPosition = String(index + 1);
        thumb.setAttribute('aria-label', '項目に移動する ' + (index + 1));
      }
    });
  }

  function refreshNavigation(nav) {
    if (!nav || typeof nav.refreshItems !== 'function') return;
    nav.refreshItems();
  }

  // 4500: move only out-of-order nodes; keep the rest connected, including video elements.
  function reconcile4500Order(parent, ordered) {
    if (window.location.pathname.replace(/\/+$/, '') !== '/products/4500' || !ordered.every(function(node) { return node.parentNode === parent; })) return false;
    var cursor = parent.firstElementChild;
    ordered.forEach(function(node) {
      node.removeAttribute('hidden');
      if (node === cursor) cursor = cursor.nextElementSibling;
      else parent.insertBefore(node, cursor);
    });
    return true;
  }

  function reorderThumbnails(gallery, orderedMediaIds) {
    var nav = gallery.querySelector('product-gallery-navigation');
    if (!nav) return;

    var thumbs = Array.from(nav.querySelectorAll('.product-gallery__thumbnail[data-media-id]'));
    if (!thumbs.length) return;

    var map = {};
    thumbs.forEach(function (thumb) {
      map[thumb.dataset.mediaId] = thumb;
      thumb.removeAttribute('hidden');
    });

    var orderedThumbs = orderedMediaIds.map(function (mediaId) {
      return map[mediaId];
    }).filter(Boolean);

    if (!sameOrder(thumbs, orderedThumbs)) {
      if (!reconcile4500Order(nav, orderedThumbs)) {
        var fragment = document.createDocumentFragment();
        orderedThumbs.forEach(function (thumb) { fragment.appendChild(thumb); });
        nav.appendChild(fragment);
      }
      refreshNavigation(nav);
    }
  }

  function updateVariantLabel(gallery, mediaId) {
    var label = gallery.querySelector('.product-gallery__variant-label');
    var mapText = gallery.getAttribute('data-media-variant-map') || '';
    if (!label || !mapText) return;

    var title = '';
    mapText.split('||').some(function (entry) {
      var parts = entry.split('::');
      if (parts[0] === mediaId) {
        title = parts.slice(1).join('::');
        return true;
      }
      return false;
    });

    label.textContent = title;
  }

  function centerCurrentThumbnail(gallery, mediaId) {
    var nav = gallery.querySelector('product-gallery-navigation');
    var current = nav && nav.querySelector('.product-gallery__thumbnail[data-media-id="' + selectorEscape(mediaId) + '"]');
    if (!nav || !current || (nav.scrollWidth <= nav.clientWidth && nav.scrollHeight <= nav.clientHeight)) return;

    nav.scrollTo({
      left: Math.max(0, current.offsetLeft - nav.clientWidth / 2 + current.clientWidth / 2),
      top: Math.max(0, current.offsetTop - nav.clientHeight / 2 + current.clientHeight / 2),
      behavior: 'auto'
    });
  }

  function setPageDots(gallery, index) {
    var dots = gallery.querySelector('.page-dots');
    if (!dots) return;

    Array.from(dots.querySelectorAll('button')).forEach(function (button, buttonIndex) {
      button.removeAttribute('hidden');
      button.setAttribute('aria-current', buttonIndex === index ? 'true' : 'false');
    });
  }

  function selectMedia(gallery, mediaId) {
    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel || !mediaId) return;

    var visibleMedia = Array.from(carousel.querySelectorAll('.product-gallery__media[data-media-id]:not([hidden])'));
    var index = visibleMedia.findIndex(function (media) {
      return media.dataset.mediaId === mediaId;
    });
    if (index === -1) return;

    if (typeof carousel.select === 'function') {
      carousel.select(index, { instant: true });
    } else {
      visibleMedia[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
    }

    visibleMedia.forEach(function (media) {
      media.classList.toggle('is-initial', media.dataset.mediaId === mediaId);
      media.classList.toggle('is-selected', media.dataset.mediaId === mediaId);
    });

    gallery.querySelectorAll('.product-gallery__thumbnail[data-media-id]').forEach(function (thumbnail) {
      thumbnail.setAttribute('aria-current', thumbnail.dataset.mediaId === mediaId ? 'true' : 'false');
    });

    setPageDots(gallery, index);
    centerCurrentThumbnail(gallery, mediaId);
    updateVariantLabel(gallery, mediaId);
  }

  function syncGallery(gallery, eventVariant) {
    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    bindGalleryForm(gallery);

    var variant = selectedVariantForGallery(gallery, eventVariant);
    var featuredMediaId = mediaIdFromVariant(variant);
    if (!featuredMediaId) {
      var current = gallery.querySelector('.product-gallery__thumbnail[aria-current="true"][data-media-id], .product-gallery__media.is-initial[data-media-id]');
      featuredMediaId = current && current.dataset.mediaId;
    }
    if (!featuredMediaId) return;

    var featuredMedia = carousel.querySelector('.product-gallery__media[data-media-id="' + selectorEscape(featuredMediaId) + '"]');
    if (!featuredMedia) return;
    var selectedColor = parseColor(mediaAlt(featuredMedia)) || colorFromVariant(variant);
    var syncKey = featuredMediaId + '|' + selectedColor;
    var previousSync = syncedGalleryVariants.get(gallery);
    if (previousSync && previousSync.carousel === carousel && previousSync.key === syncKey) return;

    var mediaEls = Array.from(carousel.querySelectorAll('.product-gallery__media[data-media-id]'));
    var initialThumbnail = gallery.querySelector('.product-gallery__thumbnail[aria-current="true"][data-media-id]');
    var initialVariantMatches = variant
      ? gallery.getAttribute('data-initial-variant') === String(variant.id)
      : (!initialThumbnail || initialThumbnail.dataset.mediaId === featuredMediaId);
    // Liquid emits the final initial order. Do not rebuild it or reset a visitor's thumbnail choice.
    if (!previousSync && gallery.hasAttribute('data-gallery-preordered') && initialVariantMatches &&
        mediaEls.length && mediaEls[0].dataset.mediaId === featuredMediaId &&
        gallery.getAttribute('filtered-indexes') === '[]') {
      syncedGalleryVariants.set(gallery, { carousel: carousel, key: syncKey });
      return;
    }
    clearThemeFiltering(gallery, carousel);
    var orderedMedia = sortMedia(mediaEls, featuredMediaId, selectedColor);
    var orderedMediaIds = mediaIdList(orderedMedia);

    if (!sameOrder(mediaEls, orderedMedia)) {
      if (!reconcile4500Order(carousel, orderedMedia)) {
        var fragment = document.createDocumentFragment();
        orderedMedia.forEach(function (media) {
          media.removeAttribute('hidden');
          fragment.appendChild(media);
        });
        carousel.appendChild(fragment);
      }
    } else {
      orderedMedia.forEach(function (media) {
        media.removeAttribute('hidden');
      });
    }

    reorderThumbnails(gallery, orderedMediaIds);
    updatePositions(orderedMedia, gallery);
    syncedGalleryVariants.set(gallery, { carousel: carousel, key: syncKey });
    selectMedia(gallery, featuredMediaId);
  }

  function scheduleGallery(gallery, variant) {
    if (!gallery) return;

    if (variant && mediaIdFromVariant(variant)) {
      rememberVariant(formIdForGallery(gallery), variant);
    }

    queuedVariants.set(gallery, variant || latestVariantsByFormId[formIdForGallery(gallery)] || null);
    if (queuedFrames.has(gallery)) return;

    queuedFrames.set(gallery, requestAnimationFrame(function () {
      var queuedVariant = queuedVariants.get(gallery);
      queuedFrames.delete(gallery);
      queuedVariants.delete(gallery);
      syncGallery(gallery, queuedVariant);
    }));
  }

  function scheduleGallerySettled(gallery, variant) {
    scheduleGallery(gallery, variant);
    setTimeout(function () {
      // A retry must use the latest selection, never replay a captured variant.
      scheduleGallery(gallery);
    }, 80);
  }

  function syncAll(variant) {
    document.querySelectorAll('product-gallery').forEach(function (gallery) {
      scheduleGallerySettled(gallery, variant);
    });
  }

  function scheduleFormGalleries(formId, variant) {
    galleriesForFormId(formId).forEach(function (gallery) {
      scheduleGallerySettled(gallery, variant);
    });
  }

  function scheduleFormGalleriesAfterOptionChange(formId) {
    scheduleFormGalleries(formId);
    setTimeout(function () {
      scheduleFormGalleries(formId);
    }, 350);
    setTimeout(function () {
      scheduleFormGalleries(formId);
    }, 900);
  }

  function bindGalleryForm(gallery) {
    var form = formForGallery(gallery);
    if (!form || boundForms.has(form)) return;

    var formId = form.getAttribute('id') || gallery.getAttribute('form');
    boundForms.set(form, true);
    form.addEventListener('product:rerender', function () {
      requestAnimationFrame(function () {
        galleriesForFormId(formId).forEach(function (nextGallery) {
          scheduleGallerySettled(nextGallery, latestVariantsByFormId[formId]);
        });
      });
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var picker = event.target.closest('variant-picker');
    if (!picker) return;

    var formId = picker.getAttribute('form-id');
    var optionInput = event.target.closest('input[data-option-position]');
    if (optionInput) {
      scheduleFormGalleriesAfterOptionChange(optionInput.getAttribute('form') || formId);
    }

    var gallery = formId ? galleriesForFormId(formId)[0] : document.querySelector('product-gallery');
    var section = gallery && gallery.closest('.shopify-section');
    if (!section) return;

    var sectionTop = section.offsetTop;
    var headerH = document.querySelector('.shopify-section-group-header-group')?.offsetHeight || 0;
    window.scrollTo({ top: Math.max(0, sectionTop - headerH), behavior: 'smooth' });
  }, true);

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    // HTMLFormElement.id can be shadowed by the variant input named "id".
    // The native theme currently passes that input as detail.formId.
    var formId = typeof detail.formId === 'string' ? detail.formId : '';
    if (!formId && event.target && typeof event.target.getAttribute === 'function') {
      var eventForm = event.target.tagName === 'FORM' ? event.target : event.target.form;
      formId = eventForm && eventForm.getAttribute('id') || '';
    }
    if (!formId) return;
    rememberVariant(formId, detail.variant);
    scheduleFormGalleries(formId, detail.variant);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
    });
  } else {
    syncAll();
  }

  window.__maruishiSyncProductGallery = syncAll;
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quantity-selector[data-multiplier]').forEach((selector) => {
    const multiplier = parseInt(selector.dataset.multiplier || '1', 10);
    const input = selector.querySelector('input.quantity-selector__input');
    const display = selector.querySelector('.quantity-display');

    if (!input || !display) return;

    const updateDisplay = () => {
      const value = parseInt(input.value || '1', 10);
      display.textContent = value * multiplier;
    };

    input.addEventListener('input', updateDisplay);
    input.addEventListener('change', updateDisplay);
    updateDisplay(); // 初期表示反映
  });
});

// Shopifyのフルページキャッシュが古い記事HTMLを返した時のカテゴリ表示補正。
// Liquid側では固定カテゴリを表示するが、古いHTMLでは article.tags.first が残ることがある。
(function() {
  var categoryHandles = {
    'お知らせ': 'お知らせ',
    '生地の選び方': '生地の選び方',
    '作り方・型紙': '作り方-型紙',
    '作品例・布合わせ': '作品例-布合わせ',
    '入園入学': '入園入学',
    '子ども服・ベビー': '子ども服-ベビー',
    '大人服・エプロン': '大人服-エプロン',
    'バッグ・小物': 'バッグ-小物',
    '犬服・ドール服': '犬服-ドール服',
    'ミシン・道具': 'ミシン-道具'
  };
  var fixedCategories = Object.keys(categoryHandles);

  function text(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function taggedBase(href) {
    var match = String(href || '').match(/^(.*\/blogs\/[^/]+)\/tagged\//);
    return match ? match[1] : '/blogs/journal';
  }

  function categoryUrl(base, category) {
    return base + '/tagged/' + categoryHandles[category];
  }

  function fixCachedArticleCategory() {
    var currentLink = document.querySelector('.article-header__category');
    if (!currentLink) return;

    var currentCategory = text(currentLink);
    if (fixedCategories.indexOf(currentCategory) !== -1) return;

    var tagTexts = Array.from(document.querySelectorAll('.article-header__tag, .article-tags-section__tag')).map(text);
    var desiredCategory = fixedCategories.find(function(category) {
      return tagTexts.indexOf(category) !== -1;
    });
    if (!desiredCategory) return;

    var base = taggedBase(currentLink.getAttribute('href'));
    currentLink.textContent = desiredCategory;
    currentLink.setAttribute('href', categoryUrl(base, desiredCategory));

    document.querySelectorAll('.article-breadcrumb a[href*="/tagged/"]').forEach(function(link) {
      if (fixedCategories.indexOf(text(link)) === -1 || text(link) === currentCategory) {
        link.textContent = desiredCategory;
        link.setAttribute('href', categoryUrl(base, desiredCategory));
      }
    });

    document.querySelectorAll('.article-header__tag').forEach(function(link) {
      if (text(link) === desiredCategory) link.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCachedArticleCategory);
  } else {
    fixCachedArticleCategory();
  }
})();

/* dogwear-video-mp4-fix-20260612 */
(function () {
  var replacements = [
    {
      oldUrl: 'https://cdn.shopify.com/videos/c/o/v/b3c32eb54dd1482b9f4fec79ab5e589a.mov',
      newUrl: 'https://cdn.shopify.com/videos/c/vp/5cc002efc49c48a092615be294a440d5/5cc002efc49c48a092615be294a440d5.HD-720p-4.5Mbps-86382851.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0944/6821/0981/files/dogwear-13-001-running-video-poster-20260612.jpg?v=1781269347'
    },
    {
      oldUrl: 'https://cdn.shopify.com/videos/c/o/v/edf0a0adc91e4985b9cee38d674e4111.mov',
      newUrl: 'https://cdn.shopify.com/videos/c/vp/aa23d307afd04b2298ea81fc553bb11f/aa23d307afd04b2298ea81fc553bb11f.HD-720p-3.0Mbps-86382904.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0944/6821/0981/files/dogwear-13-002-7000-video-poster-20260612.jpg?v=1781269371'
    }
  ];

  function replaceLinkTargets(root, oldUrl, newUrl) {
    root.querySelectorAll('a[href="' + oldUrl + '"]').forEach(function (link) {
      link.setAttribute('href', newUrl);
    });
  }

  function fixDogwearVideos() {
    replacements.forEach(function (item) {
      document.querySelectorAll('video source[src="' + item.oldUrl + '"]').forEach(function (source) {
        var video = source.closest('video');
        source.setAttribute('src', item.newUrl);
        source.setAttribute('type', 'video/mp4');
        if (video) {
          video.setAttribute('poster', item.poster);
          replaceLinkTargets(video, item.oldUrl, item.newUrl);
          video.load();
        }
      });
      replaceLinkTargets(document, item.oldUrl, item.newUrl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDogwearVideos);
  } else {
    fixDogwearVideos();
  }
})();

/* restock-alert-20260708 */
(function () {
  if (window.__maruishiRestockAlertInit) return;
  window.__maruishiRestockAlertInit = true;

  var KLAVIYO_REVISION = '2026-04-15';

  function getAlert(target) {
    return target && target.closest ? target.closest('[data-restock-alert]') : null;
  }

  function getFields(root) {
    return root ? root.querySelector('[data-restock-fields]') : null;
  }

  function getEmailInput(root) {
    return root ? root.querySelector('[data-restock-email]') : null;
  }

  function getSubmitButton(root) {
    return root ? root.querySelector('[data-restock-submit]') : null;
  }

  function getMessage(root) {
    return root ? root.querySelector('[data-restock-message]') : null;
  }

  function setMessage(root, text, state) {
    var message = getMessage(root);
    if (!message) return;
    message.textContent = text || '';
    message.classList.remove('is-success', 'is-error');
    if (state) message.classList.add('is-' + state);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function openAlert(root) {
    var fields = getFields(root);
    var input = getEmailInput(root);
    var trigger = root ? root.querySelector('[data-restock-open]') : null;
    if (!root || !fields) return;

    fields.hidden = false;
    root.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setMessage(root, '', '');

    if (input) {
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }
      window.setTimeout(function () {
        try {
          input.focus({ preventScroll: true });
        } catch (error) {
          input.focus();
        }
      }, 80);
    }
  }

  function setSubmitting(root, submitting) {
    var submit = getSubmitButton(root);
    if (!submit) return;
    submit.disabled = submitting;
    submit.textContent = submitting ? '登録しています...' : '通知を登録する';
  }

  function buildPayload(email, variantId) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };
  }

  function parseError(responseText) {
    try {
      var json = JSON.parse(responseText);
      var first = json && json.errors && json.errors[0];
      return first && (first.detail || first.title);
    } catch (error) {
      return '';
    }
    return '';
  }

  function submitAlert(root) {
    var companyId = root && root.dataset ? root.dataset.companyId : '';
    var variantId = root && root.dataset ? root.dataset.variantId : '';
    var input = getEmailInput(root);
    var email = input ? input.value.trim() : '';

    if (!isValidEmail(email)) {
      setMessage(root, 'メールアドレスを入力してください。', 'error');
      if (input) input.focus();
      return;
    }

    if (!companyId || !variantId) {
      setMessage(root, '登録できませんでした。時間をおいてもう一度お試しください。', 'error');
      return;
    }

    setSubmitting(root, true);
    setMessage(root, '', '');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(buildPayload(email, variantId))
    })
      .then(function (response) {
        if (response.ok) return '';
        return response.text().then(function (text) {
          throw new Error(parseError(text) || 'request failed');
        });
      })
      .then(function () {
        var submit = getSubmitButton(root);
        root.classList.add('is-complete');
        if (submit) {
          submit.disabled = true;
          submit.textContent = '登録済み';
        }
        setMessage(root, '登録しました。再入荷したらメールでお知らせします。', 'success');
      })
      .catch(function () {
        setMessage(root, '登録できませんでした。時間をおいてもう一度お試しください。', 'error');
      })
      .finally(function () {
        if (!root.classList.contains('is-complete')) setSubmitting(root, false);
      });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest ? event.target.closest('[data-restock-open]') : null;
    if (openButton) {
      event.preventDefault();
      openAlert(getAlert(openButton));
      return;
    }

    var submitButton = event.target.closest ? event.target.closest('[data-restock-submit]') : null;
    if (submitButton) {
      event.preventDefault();
      submitAlert(getAlert(submitButton));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (!event.target.matches || !event.target.matches('[data-restock-email]')) return;
    event.preventDefault();
    submitAlert(getAlert(event.target));
  });
})();


/* for-adult-collection-top-refresh-20260805-v1:start */
(function () {
  var expectedPath = "/collections/for-adult";
  var expectedLink = "https://kijimaru.jp/blogs/work-examples/otona";
  var expectedImageKey = "6526-104__1421485817498460160__01";

  function refreshAdultCollectionTop() {
    if (window.location.pathname !== expectedPath) return;
    if (!window.fetch || !window.DOMParser) return;

    var wrapper = document.querySelector('[id^="shopify-section-"][id$="__collection_top_7jGRy6"]');
    if (!wrapper || wrapper.dataset.forAdultTopRefresh === "done") return;

    var currentHtml = wrapper.innerHTML || "";
    if (currentHtml.indexOf(expectedLink) !== -1 && currentHtml.indexOf(expectedImageKey) !== -1) return;

    var sectionId = wrapper.id.replace(/^shopify-section-/, "");
    if (!sectionId) return;

    wrapper.dataset.forAdultTopRefresh = "done";
    fetch(expectedPath + "?section_id=" + encodeURIComponent(sectionId) + "&_for_adult_top_refresh=" + Date.now(), {
      credentials: "same-origin",
      headers: {
        "cache-control": "no-cache",
        pragma: "no-cache"
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("section refresh failed");
        return response.text();
      })
      .then(function (html) {
        if (html.indexOf(expectedLink) === -1 || html.indexOf(expectedImageKey) === -1) return;
        wrapper.innerHTML = html;
      })
      .catch(function () {
        wrapper.dataset.forAdultTopRefresh = "failed";
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshAdultCollectionTop);
  } else {
    refreshAdultCollectionTop();
  }
  window.addEventListener("pageshow", refreshAdultCollectionTop);
})();
/* for-adult-collection-top-refresh-20260805-v1:end */


;(function(){
  var flag="otonaAdultWorkGalleryFallback20260805v1";
  if(window[flag])return;
  window[flag]=true;
  var path="/blogs/work-examples/otona";
  var galleryMarker="otona-adult-work-example-gallery-20260805-v1";
  function ready(fn){document.readyState==="loading"?document.addEventListener("DOMContentLoaded",fn,{once:true}):fn()}
  function hasGallery(){return document.documentElement.innerHTML.indexOf(galleryMarker)!==-1||!!document.querySelector('[data-otona-adult-work-gallery="'+galleryMarker+'"]')}
  function targetAnchor(){var link=document.querySelector('a[href$="/collections/for-adult"], a[href*="/collections/for-adult"]');return link?link.closest("p")||link:null}
  function extractGallery(html){var doc=new DOMParser().parseFromString(html,"text/html"),gallery=doc.querySelector('[data-otona-adult-work-gallery="'+galleryMarker+'"]');if(!gallery)return"";var nodes=[],intro=gallery.previousElementSibling,heading=intro&&intro.previousElementSibling;if(heading&&heading.tagName==="H2")nodes.push(heading.outerHTML);if(intro&&intro.tagName==="P")nodes.push(intro.outerHTML);nodes.push(gallery.outerHTML);return nodes.join("\n")}
  function inject(){if(!window.location||window.location.pathname.replace(/\/+$/,"")!==path||hasGallery()||!window.fetch||!window.DOMParser)return;var anchor=targetAnchor();if(!anchor)return;var url=path+"?view=customer-creations&_otona_gallery_fallback="+Date.now();fetch(url,{credentials:"same-origin",headers:{"cache-control":"no-cache",pragma:"no-cache"}}).then(function(response){if(!response.ok)throw new Error("gallery fallback fetch failed");return response.text()}).then(function(html){if(hasGallery())return;var galleryHtml=extractGallery(html);galleryHtml&&anchor.insertAdjacentHTML("afterend",galleryHtml)}).catch(function(){})}
  ready(inject);
  window.addEventListener("pageshow",inject);
})();

/* sample-color-picker-cache-fallback-20260805-v1 */
(function() {
  var MARKER = "sample-color-picker-cache-fallback-20260805-v1";
  if (window.__kijimaruSampleColorPickerCacheFallback20260805) return;
  window.__kijimaruSampleColorPickerCacheFallback20260805 = true;

  var productCache = {};

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function sectionIdFor(root) {
    return root && root.id ? root.id.replace(/^sample-request-/, "") : "";
  }

  function bySection(prefix, root) {
    var sectionId = sectionIdFor(root);
    return sectionId ? document.getElementById(prefix + sectionId) : null;
  }

  function optionValues(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options.filter(Boolean);
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  function optionName(product, index) {
    var option = product && Array.isArray(product.options) ? product.options[index] : null;
    if (!option) return index === 0 ? "カラー" : "Option " + (index + 1);
    return typeof option === "string" ? option : option.name || "Option " + (index + 1);
  }

  function variantLabel(variant, product) {
    var values = optionValues(variant);
    if (values.length) return values.join(" / ");
    var title = variant && (variant.public_title || variant.title);
    return title && title !== "Default Title" ? title : (product && product.title) || "";
  }

  function variantImage(variant, product, width) {
    var source = variant && variant.featured_image;
    if (source && typeof source === "object") source = source.src;
    if (!source && product) source = product.featured_image || (product.images && product.images[0]);
    if (!source) return "";
    source = String(source).replace(/\?.*$/, "");
    return source + "?width=" + width;
  }

  function findVariant(product, matcher) {
    if (!product || !Array.isArray(product.variants)) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (matcher(product.variants[i])) return product.variants[i];
    }
    return null;
  }

  function currentVariant(product, root) {
    var currentId = Number(root.dataset.currentVariantId || "");
    if (currentId) {
      var byId = findVariant(product, function(variant) {
        return Number(variant.id) === currentId;
      });
      if (byId) return byId;
    }

    var values = [];
    for (var i = 1; i <= 3; i++) {
      if (root.dataset["option" + i]) values.push(root.dataset["option" + i]);
    }
    if (values.length) {
      var byOptions = findVariant(product, function(variant) {
        var opts = optionValues(variant);
        return values.every(function(value, index) {
          return opts[index] === value;
        });
      });
      if (byOptions) return byOptions;
    }

    var sku = (root.dataset.productSku || "").toLowerCase();
    if (sku) {
      var bySku = findVariant(product, function(variant) {
        return String(variant.sku || "").toLowerCase() === sku;
      });
      if (bySku) return bySku;
    }

    var productRoot = root.closest(".product") || document;
    var idInput = productRoot.querySelector('form[action*="/cart/add"] input[name="id"], product-form input[name="id"], input[name="id"]');
    if (idInput && idInput.value) {
      var byInput = findVariant(product, function(variant) {
        return Number(variant.id) === Number(idInput.value);
      });
      if (byInput) return byInput;
    }

    return product.variants && product.variants[0];
  }

  function loadProduct(handle) {
    if (!handle) return Promise.reject(new Error("missing product handle"));
    if (!productCache[handle]) {
      productCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function(response) {
        if (!response.ok) throw new Error("product json failed");
        return response.json();
      });
    }
    return productCache[handle];
  }

  function injectStyle() {
    if (document.getElementById(MARKER + "-style")) return;
    var style = document.createElement("style");
    style.id = MARKER + "-style";
    style.textContent = [
      ".sample-request__btn{background:#2c2c2c;border-color:#2c2c2c;color:#fff;box-shadow:0 1px 0 rgba(0,0,0,.18)}",
      ".sample-request__btn:hover{background:#070707;border-color:#070707;color:#fff}",
      ".sample-request-choice:has(input:checked){border-color:#2c2c2c;box-shadow:0 0 0 1px #2c2c2c inset}",
      ".sample-request-choice input{accent-color:#2c2c2c}",
      ".sample-request-color-picker{padding:12px 14px 14px;border:1px solid #D1D1D1;border-radius:8px;background:#fff}",
      ".sample-request-color-picker__head{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px}",
      ".sample-request-color-picker__title{color:#3F3A39;font-size:14px;font-weight:700;line-height:1.4}",
      ".sample-request-color-picker__count{color:#6f6258;font-size:12px;white-space:nowrap}",
      ".sample-request-color-picker__grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(112px,1fr));gap:8px}",
      ".sample-request-color-option{min-width:0;min-height:42px;padding:7px 8px;border:1px solid #DCD6CF;border-radius:8px;background:#fff;color:#3F3A39;cursor:pointer;text-align:center}",
      ".sample-request-color-option.is-selected{border-color:#2c2c2c;background:#f5f5f5;box-shadow:0 0 0 1px #2c2c2c inset}",
      ".sample-request-color-option:disabled{opacity:.45;cursor:not-allowed;background:#f7f4f0}",
      ".sample-request-color-option__name{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px;font-weight:700;line-height:1.35}",
      ".sample-request-color-option__stock{display:block;margin-top:2px;color:#777;font-size:10px;line-height:1.2}",
      ".sample-request-modal__submit{background:#bf0000}",
      "@media screen and (min-width:700px){.sample-request-modal__dialog{display:flex;flex-direction:column;overflow:hidden}.sample-request-modal__choices{flex:1 1 auto;min-height:0;overflow-y:auto}.sample-request-modal__submit{flex:0 0 auto;position:relative;bottom:auto}}",
      "@media screen and (max-width:699px){.sample-request-modal__dialog{display:flex;flex-direction:column;width:100%;height:calc(100vh - 24px - var(--sample-request-preview-offset,0px));max-height:calc(100vh - var(--sample-request-preview-offset,0px));overflow:hidden}.sample-request-modal__choices{flex:1 1 auto;min-height:0;max-height:none;overflow-y:auto;-webkit-overflow-scrolling:touch;margin-bottom:12px}.sample-request-color-picker{padding:11px 12px 12px}.sample-request-color-picker__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:7px}.sample-request-color-option{min-height:40px;padding:7px 6px}.sample-request-modal__submit{flex:0 0 auto;position:relative;bottom:auto}}",
      "@supports (height:100dvh){@media screen and (max-width:699px){.sample-request-modal__dialog{height:calc(100dvh - 24px - var(--sample-request-preview-offset,0px));max-height:calc(100dvh - var(--sample-request-preview-offset,0px))}}}"
    ].join("");
    document.head.appendChild(style);
  }

  function resetVisibleButton(root) {
    var btn = bySection("sample-request-btn-", root);
    var msg = bySection("sample-request-msg-", root);
    if (btn) {
      btn.disabled = false;
      btn.classList.remove("sample-request__btn--added");
      var text = btn.querySelector(".sample-request__text");
      var icon = btn.querySelector(".sample-request__icon");
      if (text) text.textContent = "サンプルを見る・購入する";
      if (icon) icon.textContent = "✉";
    }
    if (msg) msg.style.display = "none";
  }

  function updatePickerState(picker, variant) {
    picker.querySelectorAll("[data-sample-color-option]").forEach(function(button) {
      var selected = Number(button.dataset.variantId) === Number(variant && variant.id);
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", selected ? "true" : "false");
    });
  }

  function applyVariant(root, modal, picker, product, variant, opts) {
    if (!variant) return;
    opts = opts || {};
    var values = optionValues(variant);
    for (var i = 0; i < values.length; i++) {
      root.dataset["option" + (i + 1)] = values[i];
      root.dataset["option" + (i + 1) + "Name"] = root.dataset["option" + (i + 1) + "Name"] || optionName(product, i);
    }
    if (variant.id) root.dataset.currentVariantId = variant.id;
    if (variant.sku) root.dataset.productSku = variant.sku;

    var label = variantLabel(variant, product);
    var productTitle = root.dataset.productTitle || (product && product.title) || "";
    var colorEl = bySection("sample-request-color-", root);
    var selectedEl = bySection("sample-request-selected-", root);
    var imageEl = bySection("sample-request-fabric-image-", root);
    var image = variantImage(variant, product, 160);

    if (colorEl) colorEl.textContent = label || productTitle;
    if (selectedEl) selectedEl.textContent = "\uD83D\uDCCB " + productTitle + (label && label !== productTitle ? " / " + label : "");
    if (imageEl && image) imageEl.src = image;
    if (picker) updatePickerState(picker, variant);

    if (opts.chooseFabric && modal) {
      var fabricChoice = modal.querySelector('input[data-sample-kind="fabric"]');
      if (fabricChoice && !fabricChoice.disabled) fabricChoice.checked = true;
    }

    var modalMsg = bySection("sample-request-modal-msg-", root);
    if (modalMsg) {
      modalMsg.hidden = true;
      modalMsg.textContent = "";
      modalMsg.className = "sample-request-modal__message";
    }

    resetVisibleButton(root);
  }

  function buildPicker(root, modal, product) {
    if (!product || !Array.isArray(product.variants) || product.variants.length < 2) return null;
    if (modal.querySelector(".sample-request-color-picker")) return null;

    var picker = document.createElement("div");
    picker.className = "sample-request-color-picker";
    picker.setAttribute("aria-label", "サンプルカラーを選択");

    var head = document.createElement("div");
    head.className = "sample-request-color-picker__head";

    var title = document.createElement("span");
    title.className = "sample-request-color-picker__title";
    title.textContent = "カラーを選択";

    var count = document.createElement("span");
    count.className = "sample-request-color-picker__count";
    count.textContent = product.variants.length + "色";

    var grid = document.createElement("div");
    grid.className = "sample-request-color-picker__grid";

    product.variants.forEach(function(variant) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "sample-request-color-option";
      button.dataset.sampleColorOption = "true";
      button.dataset.variantId = variant.id;
      button.setAttribute("aria-pressed", "false");
      if (!variant.available) button.disabled = true;

      var name = document.createElement("span");
      name.className = "sample-request-color-option__name";
      name.textContent = variantLabel(variant, product);
      button.appendChild(name);

      if (!variant.available) {
        var stock = document.createElement("span");
        stock.className = "sample-request-color-option__stock";
        stock.textContent = "売り切れ";
        button.appendChild(stock);
      }

      button.addEventListener("click", function() {
        if (button.disabled) return;
        applyVariant(root, modal, picker, product, variant, { chooseFabric: true });
      });

      grid.appendChild(button);
    });

    head.appendChild(title);
    head.appendChild(count);
    picker.appendChild(head);
    picker.appendChild(grid);

    var fabricChoice = modal.querySelector('input[data-sample-kind="fabric"]');
    var anchor = fabricChoice && fabricChoice.closest(".sample-request-choice");
    var choices = modal.querySelector(".sample-request-modal__choices");
    if (anchor) {
      anchor.insertAdjacentElement("afterend", picker);
    } else if (choices) {
      choices.insertAdjacentElement("afterbegin", picker);
    }

    applyVariant(root, modal, picker, product, currentVariant(product, root), {});
    return picker;
  }

  function enhance(root) {
    if (!root || root.dataset.sampleColorPickerFallbackReady === "true") return;
    var modal = bySection("sample-request-modal-", root);
    if (!modal || modal.querySelector(".sample-request-color-picker")) return;
    var handle = root.dataset.productHandle;
    if (!handle) return;

    root.dataset.sampleColorPickerFallbackReady = "true";
    loadProduct(handle).then(function(product) {
      injectStyle();
      var picker = buildPicker(root, modal, product);
      if (!picker) return;

      var sync = function() {
        setTimeout(function() {
          applyVariant(root, modal, picker, product, currentVariant(product, root), {});
        }, 120);
      };
      var btn = bySection("sample-request-btn-", root);
      if (btn) btn.addEventListener("click", sync);
      document.addEventListener("variant:change", sync);
      var productRoot = root.closest(".product");
      if (productRoot) {
        productRoot.addEventListener("change", sync);
        productRoot.addEventListener("click", function(event) {
          if (event.target.closest(".fabric-variant-card, [data-option-position], variant-picker")) sync();
        }, true);
      }
    }).catch(function() {
      delete root.dataset.sampleColorPickerFallbackReady;
    });
  }

  function scan() {
    document.querySelectorAll(".sample-request").forEach(enhance);
  }

  ready(function() {
    scan();
    setTimeout(scan, 500);
    setTimeout(scan, 1500);
  });
  window.addEventListener("pageshow", scan);
})();

//# sourceMappingURL=/cdn/shop/t/116/assets/custom.js.map?v=20260805-for-adult-image-link-v1

/* kodomo-article-intro-cache-refresh-20260805-v1:start */
(function () {
  var expectedPath = "/blogs/work-examples/kodomo";
  var markerSelector = '[data-kodomo-child-work-gallery="kodomo-child-work-example-gallery-20260805-v1"]';
  var wantedText = "子供服の作品例をまとめています。気になる生地や型紙は、写真下の商品名から確認できます。";

  function fixKodomoArticleIntro() {
    if (window.location.pathname !== expectedPath) return;

    var gallery = document.querySelector(markerSelector);
    if (!gallery) return;

    var prose = gallery.closest(".prose") || gallery.parentElement;
    if (!prose || prose.dataset.kodomoIntroFix === "done") return;

    var previous = gallery.previousElementSibling;
    while (previous && /^(P|H2)$/i.test(previous.tagName)) {
      var text = (previous.textContent || "").trim();
      var shouldRemove =
        text === "最近追加した子供服の作品例" ||
        text.indexOf("商品ページに追加した作品例から") !== -1;
      var nextPrevious = previous.previousElementSibling;
      if (shouldRemove) previous.remove();
      previous = nextPrevious;
    }

    var lead = prose.querySelector("p");
    if (lead && lead.textContent.trim() !== wantedText) {
      var leadText = lead.textContent || "";
      if (leadText.indexOf("子供服の作品例") !== -1 || leadText.indexOf("最近商品ページに追加した写真") !== -1) {
        lead.textContent = wantedText;
      }
    }

    prose.dataset.kodomoIntroFix = "done";
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixKodomoArticleIntro);
  } else {
    fixKodomoArticleIntro();
  }
  window.addEventListener("pageshow", fixKodomoArticleIntro);
})();
/* kodomo-article-intro-cache-refresh-20260805-v1:end */

/* blog-search-all-link-runtime-hide-20260805-v1 */
(function() {
  function removeBlogSearchExtras() {
    document.querySelectorAll('.blog-search, .article-search-wrapper').forEach(function(node) {
      node.remove();
    });

    document.querySelectorAll('.blog-tags li').forEach(function(item) {
      var text = (item.textContent || '').replace(/\s+/g, '');
      if (text === '全てを見る' || text === 'すべて見る' || text === '全ての記事' || text === 'すべての記事') {
        item.remove();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeBlogSearchExtras);
  } else {
    removeBlogSearchExtras();
  }

  new MutationObserver(removeBlogSearchExtras).observe(document.documentElement, { childList: true, subtree: true });
})();


/* work-examples-category-tags-hidden-20260805-v1 */
(function() {
  function redirectStaleWorkExamplesPages() {
    var pathname = window.location.pathname.replace(/\/$/, '');
    if (/[?&]view=/.test(window.location.search)) return false;
    if (pathname === '/blogs/work-examples') {
      window.location.replace('/blogs/work-examples?view=work-examples-clean');
      return true;
    }
    if (pathname === '/blogs/work-examples/baby') {
      window.location.replace('/blogs/work-examples/baby?view=default');
      return true;
    }
    return false;
  }

  function hideWorkExamplesCategoryTags() {
    if (redirectStaleWorkExamplesPages()) return;
    var pathname = window.location.pathname.replace(/\/$/, '');
    if (pathname.indexOf('/blogs/work-examples') !== 0) return;
    document.querySelectorAll('.blog-category-list, .blog-category-list__tags, .blog-tags').forEach(function(node) {
      node.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideWorkExamplesCategoryTags);
  } else {
    hideWorkExamplesCategoryTags();
  }

  new MutationObserver(hideWorkExamplesCategoryTags).observe(document.documentElement, { childList: true, subtree: true });
})();

/* sewing-book-work-examples-move-runtime-fallback-20260805-v1:start */
(function () {
  var redirects = {
    "/blogs/journal/sewing-book-work-examples": "/blogs/work-examples/sewing-book-work-examples",
    "/blogs/journal/sewing-book-boys-girls-clothes-work-examples": "/blogs/work-examples/sewing-book-boys-girls-clothes-work-examples",
    "/blogs/journal/sewing-book-small-kids-praised-clothes-work-examples": "/blogs/work-examples/sewing-book-small-kids-praised-clothes-work-examples",
    "/blogs/journal/sewing-book-small-kids-handmade-clothes-work-examples": "/blogs/work-examples/sewing-book-small-kids-handmade-clothes-work-examples",
    "/blogs/journal/sewing-book-kids-clothes-lesson-work-examples": "/blogs/work-examples/sewing-book-kids-clothes-lesson-work-examples",
    "/blogs/journal/sewing-book-mama-kids-favorite-work-examples": "/blogs/work-examples/sewing-book-mama-kids-favorite-work-examples",
    "/blogs/journal/sewing-book-girls-everyday-clothes-series-work-examples": "/blogs/work-examples/sewing-book-girls-everyday-clothes-series-work-examples",
    "/blogs/journal/sewing-book-kids-kimono-work-examples": "/blogs/work-examples/sewing-book-kids-kimono-work-examples",
    "/blogs/journal/sewing-book-girls-boys-everyday-clothes-work-examples": "/blogs/work-examples/sewing-book-girls-boys-everyday-clothes-work-examples",
    "/blogs/journal/sewing-book-sweet-clothes-series-work-examples": "/blogs/work-examples/sewing-book-sweet-clothes-series-work-examples",
    "/blogs/journal/sewing-book-doll-kids-handmade-clothes-work-examples": "/blogs/work-examples/sewing-book-doll-kids-handmade-clothes-work-examples",
    "/blogs/journal/sewing-book-cute-shape-kids-clothes-work-examples": "/blogs/work-examples/sewing-book-cute-shape-kids-clothes-work-examples",
    "/blogs/journal/sewing-book-easy-neat-looking-clothes-work-examples": "/blogs/work-examples/sewing-book-easy-neat-looking-clothes-work-examples",
    "/blogs/journal/sewing-book-simple-easy-everyday-clothes-work-examples": "/blogs/work-examples/sewing-book-simple-easy-everyday-clothes-work-examples",
    "/blogs/journal/sewing-book-little-kids-memory-clothes-work-examples": "/blogs/work-examples/sewing-book-little-kids-memory-clothes-work-examples",
    "/blogs/journal/sewing-book-boys-girls-handmade-gift-work-examples": "/blogs/work-examples/sewing-book-boys-girls-handmade-gift-work-examples",
    "/blogs/journal/sewing-book-90-130-kids-clothes-work-examples": "/blogs/work-examples/sewing-book-90-130-kids-clothes-work-examples",
    "/blogs/journal/sewing-book-haru-kids-clothes-work-examples": "/blogs/work-examples/sewing-book-haru-kids-clothes-work-examples",
    "/blogs/journal/sewing-book-girls-daily-clothes-work-examples": "/blogs/work-examples/sewing-book-girls-daily-clothes-work-examples",
    "/blogs/journal/sewing-book-fabric-examples": "/blogs/work-examples/sewing-book-work-examples",
    "/blogs/journal/boys-girls-clothes-work-examples": "/blogs/work-examples/sewing-book-boys-girls-clothes-work-examples",
    "/blogs/journal/boys-girls-clothes-book-fabric-examples": "/blogs/work-examples/sewing-book-boys-girls-clothes-work-examples",
    "/blogs/journal/boys-girls-clothes-fabric-examples": "/blogs/work-examples/sewing-book-boys-girls-clothes-work-examples",
    "/blogs/journal/sewing-book-boys-girls-fabric-examples": "/blogs/work-examples/sewing-book-boys-girls-clothes-work-examples",
    "/blogs/journal/small-kids-praised-clothes-fabric-examples": "/blogs/work-examples/sewing-book-small-kids-praised-clothes-work-examples",
    "/blogs/journal/small-kids-handmade-clothes-fabric-examples": "/blogs/work-examples/sewing-book-small-kids-handmade-clothes-work-examples",
    "/blogs/journal/kids-clothes-lesson-book-fabric-examples": "/blogs/work-examples/sewing-book-kids-clothes-lesson-work-examples",
    "/blogs/journal/mama-kids-favorite-fabric-examples": "/blogs/work-examples/sewing-book-mama-kids-favorite-work-examples",
    "/blogs/journal/girls-everyday-clothes-series-fabric-examples": "/blogs/work-examples/sewing-book-girls-everyday-clothes-series-work-examples",
    "/blogs/journal/girls-everyday-clothes-fabric-examples": "/blogs/work-examples/sewing-book-girls-everyday-clothes-series-work-examples",
    "/blogs/journal/girls-everyday-clothes-revised-fabric-examples": "/blogs/work-examples/sewing-book-girls-everyday-clothes-series-work-examples",
    "/blogs/journal/kids-kimono-book-fabric-examples": "/blogs/work-examples/sewing-book-kids-kimono-work-examples",
    "/blogs/journal/girls-boys-everyday-clothes-fabric-examples": "/blogs/work-examples/sewing-book-girls-boys-everyday-clothes-work-examples",
    "/blogs/journal/sweet-clothes-series-fabric-examples": "/blogs/work-examples/sewing-book-sweet-clothes-series-work-examples",
    "/blogs/journal/doll-kids-handmade-clothes-fabric-examples": "/blogs/work-examples/sewing-book-doll-kids-handmade-clothes-work-examples",
    "/blogs/journal/cute-shape-kids-clothes-fabric-examples": "/blogs/work-examples/sewing-book-cute-shape-kids-clothes-work-examples",
    "/blogs/journal/easy-neat-looking-clothes-fabric-examples": "/blogs/work-examples/sewing-book-easy-neat-looking-clothes-work-examples",
    "/blogs/journal/simple-easy-everyday-clothes-fabric-examples": "/blogs/work-examples/sewing-book-simple-easy-everyday-clothes-work-examples",
    "/blogs/journal/little-kids-memory-clothes-fabric-examples": "/blogs/work-examples/sewing-book-little-kids-memory-clothes-work-examples",
    "/blogs/journal/boys-girls-handmade-gift-fabric-guide": "/blogs/work-examples/sewing-book-boys-girls-handmade-gift-work-examples",
    "/blogs/journal/boys-girls-handmade-gift-clothes-work-examples": "/blogs/work-examples/sewing-book-boys-girls-handmade-gift-work-examples",
    "/blogs/journal/boys-girls-handmade-gift-clothes-fabric-examples": "/blogs/work-examples/sewing-book-boys-girls-handmade-gift-work-examples",
    "/blogs/journal/90-130-kids-clothes-fabric-examples": "/blogs/work-examples/sewing-book-90-130-kids-clothes-work-examples",
    "/blogs/journal/haru-kids-clothes-fabric-examples": "/blogs/work-examples/sewing-book-haru-kids-clothes-work-examples",
    "/blogs/journal/girls-daily-clothes-fabric-examples": "/blogs/work-examples/sewing-book-girls-daily-clothes-work-examples"
};

  function normalizedPath(pathname) {
    return String(pathname || "").replace(/\/$/, "");
  }

  function targetForPath(pathname) {
    return redirects[normalizedPath(pathname)] || null;
  }

  function redirectCurrentPage() {
    var target = targetForPath(window.location.pathname);
    if (!target) return false;
    window.location.replace(target + window.location.search + window.location.hash);
    return true;
  }

  function normalizeSewingBookLinks() {
    document.querySelectorAll('a[href*="/blogs/journal/"], a[href*="shopify://blogs/journal/"]').forEach(function (link) {
      var raw = link.getAttribute("href") || link.href || "";
      try {
        var url = new URL(raw, window.location.origin);
        var target = targetForPath(url.pathname);
        if (!target) return;
        url.pathname = target;
        var next = /^https?:/i.test(raw) ? url.toString() : url.pathname + url.search + url.hash;
        link.setAttribute("href", next);
        link.href = next;
      } catch (error) {
        Object.keys(redirects).forEach(function (oldPath) {
          if (raw.indexOf(oldPath) === -1) return;
          link.setAttribute("href", raw.replace(oldPath, redirects[oldPath]));
        });
      }
    });
  }

  if (redirectCurrentPage()) return;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", normalizeSewingBookLinks);
  } else {
    normalizeSewingBookLinks();
  }
})();
/* sewing-book-work-examples-move-runtime-fallback-20260805-v1:end */

/* work-examples-blog-move-runtime-fallback-20260805-v1:start */
(function () {
  var redirects = {
    "/blogs/journal/otona": "/blogs/work-examples/otona",
    "/blogs/journal/otona-zakka": "/blogs/work-examples/otona-zakka",
    "/blogs/journal/kodomo": "/blogs/work-examples/kodomo",
    "/blogs/journal/baby": "/blogs/work-examples/baby"
  };
  var oldAdultPath = "/blogs/journal/otona";
  var adultUrl = "https://kijimaru.jp/blogs/work-examples/otona";
  var zakkaUrl = "https://kijimaru.jp/blogs/work-examples/otona-zakka";
  var topWorkUrl = "https://kijimaru.jp/pages/work-finder";

  function pathFromHref(href) {
    try {
      return new URL(href, window.location.origin).pathname;
    } catch (error) {
      return "";
    }
  }

  function setLinkText(link, text) {
    var span = link.querySelector("span");
    if (span) {
      span.textContent = text;
    } else {
      link.textContent = text;
    }
  }

  function groupHasZakkaLink(parent) {
    return Boolean(parent && parent.querySelector && parent.querySelector('a[href*="/blogs/work-examples/otona-zakka"]'));
  }

  function compactText(node) {
    return (node && node.textContent ? node.textContent : "").replace(/\s+/g, "").trim();
  }

  function linkTitle(link) {
    return compactText(link);
  }

  function setPlainLink(link, title, url) {
    if (!link) return;
    link.href = url;
    link.setAttribute("href", url);
    link.setAttribute("aria-label", title === "人気" ? "ランキング" : title);
    if (link.hasAttribute("aria-current")) link.removeAttribute("aria-current");
    setLinkText(link, title);
  }


  function splitOldAdultMenuLink(link) {
    if (pathFromHref(link.getAttribute("href") || link.href) !== oldAdultPath) return;

    var listItem = link.closest("li");
    var cloneSource = listItem || link;
    var parent = cloneSource.parentElement;
    if (!parent) return;
    var shouldAddZakka = !groupHasZakkaLink(parent);

    link.href = adultUrl;
    link.setAttribute("href", adultUrl);
    setLinkText(link, "大人服の作品例");

    if (!shouldAddZakka) return;

    var clone = cloneSource.cloneNode(true);
    var cloneLink = clone.matches && clone.matches("a") ? clone : clone.querySelector("a");
    if (!cloneLink) return;
    cloneLink.href = zakkaUrl;
    cloneLink.setAttribute("href", zakkaUrl);
    if (cloneLink.hasAttribute("aria-current")) cloneLink.removeAttribute("aria-current");
    setLinkText(cloneLink, "大人の雑貨");
    cloneSource.insertAdjacentElement("afterend", clone);
  }

  function normalizeStaleWorkExampleLinks() {
    document.querySelectorAll('a[href*="/blogs/journal/otona"]').forEach(splitOldAdultMenuLink);
  }

  function primaryMenuItemFromNode(node) {
    var link = node.querySelector(":scope > a[href]") || node.querySelector(":scope summary[data-follow-link]") || node.querySelector("a[href]");
    if (!link) return null;
    var title = linkTitle(link);
    var href = link.getAttribute("href") || link.getAttribute("data-follow-link") || link.href || "#";
    if (!title || !href) return null;
    return {
      title: title,
      href: href,
      current: link.hasAttribute("aria-current")
    };
  }

  function syncMobileTopNavWithPrimaryMenu() {
    var mobileList = document.querySelector(".header__mobile-menu-list");
    var primaryList = document.querySelector(".header__primary-nav > ul.contents");
    if (!mobileList || !primaryList) return;

    var sourceItems = Array.from(primaryList.children || [])
      .map(primaryMenuItemFromNode)
      .filter(Boolean)
      .filter(function(item){return ["生地を探す","型紙","副資材","作品例","読み物","サンプル"].indexOf(item.title) !== -1;}).slice(0, 6);
    if (!sourceItems.length) return;

    var nodes = Array.from(mobileList.children || []);
    sourceItems.forEach(function (item, index) {
      var node = nodes[index];
      if (!node) {
        node = nodes[0] ? nodes[0].cloneNode(true) : document.createElement("li");
        node.className = node.className || "header__mobile-menu-item";
      }

      var link = node.querySelector && node.querySelector("a");
      if (!link) {
        link = document.createElement("a");
        link.className = "header__mobile-menu-link";
        node.textContent = "";
        node.appendChild(link);
      }

      link.href = item.href;
      link.setAttribute("href", item.href);
      link.setAttribute("aria-label", item.title);
      if (item.current) link.setAttribute("aria-current", "page");
      else if (link.hasAttribute("aria-current")) link.removeAttribute("aria-current");
      setLinkText(link, item.title);
      link.style.paddingInline = "4px";
      link.style.fontSize = "13.5px";
      link.style.fontWeight = "700";

      node.style.flex = "0 0 16.666666%";
      node.style.width = "16.666666%";
      node.style.maxWidth = "16.666666%";
      node.style.minWidth = "0";
      node.style.display = "";
      mobileList.appendChild(node);
    });

    Array.from(mobileList.children || []).forEach(function (node, index) {
      if (index >= sourceItems.length) node.remove();
    });
  }

  function normalizeDesktopTopNav() {
    var list = document.querySelector(".header__primary-nav > ul.contents");
    if (!list) return;

    var nodes = Array.from(list.children || []);
    var workNode = nodes.find(function (node) {
      var link = node.querySelector && node.querySelector("a");
      return linkTitle(link) === "作品例" || (link && pathFromHref(link.getAttribute("href") || link.href) === "/blogs/work-examples");
    });

    if (!workNode) {
      workNode = document.createElement("li");
      workNode.className = "header__primary-nav-item";
      workNode.setAttribute("data-title", "作品例");
      var link = document.createElement("a");
      link.className = "block h6";
      workNode.appendChild(link);
    }

    setPlainLink(workNode.querySelector("a"), "作品例", topWorkUrl);

    var afterNode = Array.from(list.children || []).find(function (node) {
      return node.getAttribute("data-title") === "副資材" || compactText(node) === "副資材";
    });
    var beforeNode = Array.from(list.children || []).find(function (node) {
      return node.getAttribute("data-title") === "読み物" || compactText(node) === "読み物";
    });
    if (afterNode && afterNode !== workNode) {
      list.insertBefore(workNode, afterNode.nextSibling);
    } else if (beforeNode && beforeNode !== workNode) {
      list.insertBefore(workNode, beforeNode);
    } else if (!workNode.parentElement) {
      list.appendChild(workNode);
    }
  }

  function normalizeWorkExampleNavigation() {
    normalizeStaleWorkExampleLinks();
    normalizeDesktopTopNav();
    syncMobileTopNavWithPrimaryMenu();
  }

  var target = redirects[window.location.pathname];
  if (target) {
    window.location.replace(target + (window.location.search || "") + (window.location.hash || ""));
    return;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", normalizeWorkExampleNavigation);
  } else {
    normalizeWorkExampleNavigation();
  }
  window.setTimeout(normalizeWorkExampleNavigation, 250);
  window.setTimeout(normalizeWorkExampleNavigation, 1000);
  window.addEventListener("pageshow", normalizeWorkExampleNavigation);
})();
/* work-examples-blog-move-runtime-fallback-20260805-v1:end */

/* header-mobile-nav-font-b-runtime-20260805 */
(function() {
  var id = "header-mobile-nav-font-b-runtime-20260805";
  var css = [
    "@media screen and (max-width:699px){",
    ".shopify-section--header .header__mobile-menu-list{overflow-x:hidden!important;}",
    ".shopify-section--header .header__mobile-menu-list .header__mobile-menu-item{flex:0 0 16.666666%!important;width:16.666666%!important;max-width:16.666666%!important;min-width:0!important;}",
    ".shopify-section--header .header__mobile-menu-list .header__mobile-menu-item:nth-child(n+7){display:none!important;}",
    ".shopify-section--header .header__mobile-menu-link{padding-inline:4px!important;font-size:13.5px!important;font-weight:700!important;letter-spacing:0!important;}",
    "}"
  ].join("");

  function installHeaderMobileNavFont() {
    if (document.getElementById(id)) return;
    var style = document.createElement("style");
    style.id = id;
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", installHeaderMobileNavFont, { once: true });
  } else {
    installHeaderMobileNavFont();
  }
})();

/* summer-recommended-app-shelf-refresh-20260805-v1:start */
(function () {
  "use strict";

  var rawSectionId = "summer_recommended_fabrics_home";
  var expectedTitle = "夏のおすすめ生地";
  var expectedLink = "/collections/summer-recommended-fabrics";

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function hasCurrentShelf(node) {
    if (!node) return false;
    var text = node.textContent || "";
    return text.indexOf(expectedTitle) !== -1 && node.innerHTML.indexOf(expectedLink) !== -1;
  }

  function buildSectionIdFromAnchor(anchor) {
    if (!anchor || !anchor.id) return "";
    var id = anchor.id.replace(/^shopify-section-/, "");
    if (id.indexOf("__new_arrivals_top") === -1) return "";
    return id.replace(/__new_arrivals_top$/, "__" + rawSectionId);
  }

  function insertShelf(html, anchor, existing) {
    if (!html || html.indexOf(expectedTitle) === -1 || html.indexOf(expectedLink) === -1) return;

    var template = document.createElement("template");
    template.innerHTML = html.trim();
    var section = template.content.firstElementChild;
    if (!section) return;

    if (existing) existing.replaceWith(section);
    else anchor.parentNode.insertBefore(section, anchor);
  }

  function refreshSummerShelf() {
    if (!isHome() || !window.fetch) return;

    var existing = document.querySelector('[id$="__' + rawSectionId + '"]');
    if (hasCurrentShelf(existing)) return;

    var anchor = document.querySelector('[id$="__new_arrivals_top"]');
    if (!anchor || !anchor.parentNode || anchor.dataset.summerShelfRefresh === "loading") return;

    var sectionId = buildSectionIdFromAnchor(anchor);
    if (!sectionId) return;

    anchor.dataset.summerShelfRefresh = "loading";

    var url = new URL(window.location.href);
    url.search = "";
    url.searchParams.set("section_id", sectionId);
    url.searchParams.set("_summer_shelf_refresh", "20260805");

    fetch(url.toString(), {
      credentials: "same-origin",
      headers: {
        Accept: "text/html",
        "cache-control": "no-cache",
        pragma: "no-cache"
      }
    })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(function (html) {
        insertShelf(html, anchor, existing);
        anchor.dataset.summerShelfRefresh = "done";
      })
      .catch(function () {
        anchor.dataset.summerShelfRefresh = "failed";
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshSummerShelf);
  } else {
    refreshSummerShelf();
  }
  window.addEventListener("pageshow", refreshSummerShelf);
})();
/* summer-recommended-app-shelf-refresh-20260805-v1:end */

/* work-examples-sewing-book-cover-fallback-20260805-v1 */
(() => {
  const map = {
  "sewing-book-90-130-kids-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-90-130-kids-clothes-20260805.jpg?v=1785938628",
    "alt": "ハンドメイドベビー服enannaの90-130センチサイズのこども服 表紙"
  },
  "sewing-book-boys-girls-handmade-gift-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-boys-girls-handmade-gift-20260805.jpg?v=1785938626",
    "alt": "男の子にも女の子にも、作ってあげたい服 表紙"
  },
  "sewing-book-little-kids-memory-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-little-kids-memory-clothes-20260805.jpg?v=1785938623",
    "alt": "思い出を重ねる 小さな子どものお洋服 表紙"
  },
  "sewing-book-simple-easy-everyday-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-simple-easy-everyday-clothes-20260805.jpg?v=1785938621",
    "alt": "a sunny spot シンプルで着やすい まいにち服 表紙"
  },
  "sewing-book-easy-neat-looking-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-easy-neat-looking-clothes-20260805.jpg?v=1785938619",
    "alt": "ラクしてきれいに見える服 表紙"
  },
  "sewing-book-cute-shape-kids-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-cute-shape-kids-clothes-20260805.jpg?v=1785938616",
    "alt": "かわいいかたちの子ども服 表紙"
  },
  "sewing-book-doll-kids-handmade-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-doll-kids-handmade-clothes-20260805.jpg?v=1785938614",
    "alt": "おそろいで着せたい、ドールと子どもの手づくり服 表紙"
  },
  "sewing-book-girls-boys-everyday-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-girls-boys-everyday-clothes-20260805.jpg?v=1785938610",
    "alt": "女の子と男の子のいつもの服 表紙"
  },
  "sewing-book-kids-kimono-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-kids-kimono-20260805.jpg?v=1785938607",
    "alt": "はじめてでも縫えるこどものきもの 表紙"
  },
  "sewing-book-girls-everyday-clothes-series-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-girls-everyday-clothes-20260805.jpg?v=1785938604",
    "alt": "まいにち着る 女の子服 増補改訂版 表紙"
  },
  "sewing-book-kids-clothes-lesson-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-kids-clothes-lesson-20260805.jpg?v=1785938599",
    "alt": "挫折しない子ども服レッスンBOOK 表紙"
  },
  "sewing-book-small-kids-handmade-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-small-kids-handmade-clothes-20260805.jpg?v=1785938597",
    "alt": "小さな子どもの手づくり服 表紙"
  },
  "sewing-book-small-kids-praised-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-small-kids-praised-clothes-20260805.jpg?v=1785938594",
    "alt": "小さな子どもの褒められ服 表紙"
  },
  "sewing-book-boys-girls-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-boys-girls-clothes-20260805.jpg?v=1785938592",
    "alt": "男の子にも女の子にも似合う服 表紙"
  },
  "sewing-book-girls-daily-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-girls-daily-clothes-20260805.jpg?v=1785938633",
    "alt": "a sunny spot 女の子のまいにちの服 表紙"
  },
  "sewing-book-haru-kids-clothes-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-haru-kids-clothes-20260805.jpg?v=1785938631",
    "alt": "haruのこども服 表紙"
  },
  "sewing-book-sweet-clothes-series-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-sweet-clothes-20260805.jpg?v=1785938612",
    "alt": "大人だから、甘い服 表紙"
  },
  "sewing-book-mama-kids-favorite-work-examples": {
    "src": "//cdn.shopify.com/s/files/1/0944/6821/0981/articles/sewing-book-cover-mama-kids-favorite-20260805.jpg?v=1785938602",
    "alt": "ママと子どものお気に入り june -little closet- の褒められ服 表紙"
  }
};
  const widths = [300, 400, 500, 600, 800, 1000, 1200];

  function withWidth(src, width) {
    const joiner = src.includes("?") ? "&" : "?";
    return src + joiner + "width=" + width;
  }

  function updateCard(handle, data) {
    const link = document.querySelector('a[href*="/blogs/work-examples/' + handle + '"]');
    if (!link) return;
    const card = link.closest("article.blog-post-card") || link.closest("article");
    if (!card) return;
    const img = card.querySelector("img");
    if (!img || img.src.includes("sewing-book-cover-")) return;
    img.src = withWidth(data.src, 1200);
    img.srcset = widths.map((width) => withWidth(data.src, width) + " " + width + "w").join(", ");
    img.alt = data.alt;
    img.width = 1200;
    img.height = 900;
  }

  function run() {
    if (location.pathname !== "/blogs/work-examples") return;
    Object.entries(map).forEach(([handle, data]) => updateCard(handle, data));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
  setTimeout(run, 400);
  setTimeout(run, 1400);
})();

/* summer-recommended-app-shelf-flick-20260805-v1:start */
(function () {
  "use strict";

  var rawSectionId = "summer_recommended_fabrics_flick";
  var legacySectionIds = ["summer_recommended_fabrics_home"];
  window.__summerRecommendedAppShelfRefresh = "summer-recommended-app-shelf-flick-20260805-v1";
  var expectedTitle = "夏のおすすめ生地";
  var expectedLink = "/collections/summer-recommended-fabrics";

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function hasCurrentShelf(node) {
    if (!node) return false;
    var text = node.textContent || "";
    return text.indexOf(expectedTitle) !== -1 && node.innerHTML.indexOf(expectedLink) !== -1;
  }

  function buildSectionIdFromAnchor(anchor) {
    if (!anchor || !anchor.id) return "";
    var id = anchor.id.replace(/^shopify-section-/, "");
    if (id.indexOf("__new_arrivals_top") === -1) return "";
    return id.replace(/__new_arrivals_top$/, "__" + rawSectionId);
  }

  function removeLegacyShelves(current) {
    legacySectionIds.forEach(function (legacyId) {
      var legacy = document.querySelector('[id$="__' + legacyId + '"]');
      if (legacy && legacy !== current) legacy.remove();
    });
  }

  function insertShelf(html, anchor, existing) {
    if (!html || html.indexOf(expectedTitle) === -1 || html.indexOf(expectedLink) === -1) return;

    var template = document.createElement("template");
    template.innerHTML = html.trim();
    var section = template.content.firstElementChild;
    if (!section) return;

    if (existing) existing.replaceWith(section);
    else anchor.parentNode.insertBefore(section, anchor);
    removeLegacyShelves(section);
  }

  function refreshSummerShelf() {
    if (!isHome() || !window.fetch) return;

    var existing = document.querySelector('[id$="__' + rawSectionId + '"]');
    if (hasCurrentShelf(existing)) {
      removeLegacyShelves(existing);
      return;
    }

    var anchor = document.querySelector('[id$="__new_arrivals_top"]');
    if (!anchor || !anchor.parentNode || anchor.dataset.summerShelfRefresh === "loading") return;

    var sectionId = buildSectionIdFromAnchor(anchor);
    if (!sectionId) return;

    anchor.dataset.summerShelfRefresh = "loading";

    var url = new URL(window.location.href);
    url.search = "";
    url.searchParams.set("section_id", sectionId);
    url.searchParams.set("_summer_shelf_refresh", "20260805");

    fetch(url.toString(), {
      credentials: "same-origin",
      headers: {
        Accept: "text/html",
        "cache-control": "no-cache",
        pragma: "no-cache"
      }
    })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(function (html) {
        insertShelf(html, anchor, existing);
        anchor.dataset.summerShelfRefresh = "done";
      })
      .catch(function () {
        anchor.dataset.summerShelfRefresh = "failed";
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshSummerShelf);
  } else {
    refreshSummerShelf();
  }
  window.addEventListener("pageshow", refreshSummerShelf);
})();
/* summer-recommended-app-shelf-flick-20260805-v1:end */

/* summer-recommended-app-shelf-flick30-20260805-v1:start */
(function () {
  "use strict";

  var rawSectionId = "summer_recommended_fabrics_flick_30";
  var legacySectionIds = ["summer_recommended_fabrics_home","summer_recommended_fabrics_flick"];
  window.__summerRecommendedAppShelfRefresh = "summer-recommended-app-shelf-flick30-20260805-v1";
  var expectedTitle = "夏のおすすめ生地";
  var expectedLink = "/collections/summer-recommended-fabrics";

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function hasCurrentShelf(node) {
    if (!node) return false;
    var text = node.textContent || "";
    return text.indexOf(expectedTitle) !== -1 && node.innerHTML.indexOf(expectedLink) !== -1;
  }

  function buildSectionIdFromAnchor(anchor) {
    if (!anchor || !anchor.id) return "";
    var id = anchor.id.replace(/^shopify-section-/, "");
    if (id.indexOf("__new_arrivals_top") === -1) return "";
    return id.replace(/__new_arrivals_top$/, "__" + rawSectionId);
  }

  function removeLegacyShelves(current) {
    legacySectionIds.forEach(function (legacyId) {
      var legacy = document.querySelector('[id$="__' + legacyId + '"]');
      if (legacy && legacy !== current) legacy.remove();
    });
  }

  function insertShelf(html, anchor, existing) {
    if (!html || html.indexOf(expectedTitle) === -1 || html.indexOf(expectedLink) === -1) return;

    var template = document.createElement("template");
    template.innerHTML = html.trim();
    var section = template.content.firstElementChild;
    if (!section) return;

    if (existing) existing.replaceWith(section);
    else anchor.parentNode.insertBefore(section, anchor);
    removeLegacyShelves(section);
  }

  function refreshSummerShelf() {
    if (!isHome() || !window.fetch) return;

    var existing = document.querySelector('[id$="__' + rawSectionId + '"]');
    if (hasCurrentShelf(existing)) {
      removeLegacyShelves(existing);
      return;
    }

    var anchor = document.querySelector('[id$="__new_arrivals_top"]');
    if (!anchor || !anchor.parentNode || anchor.dataset.summerShelfRefresh === "loading") return;

    var sectionId = buildSectionIdFromAnchor(anchor);
    if (!sectionId) return;

    anchor.dataset.summerShelfRefresh = "loading";

    var url = new URL(window.location.href);
    url.search = "";
    url.searchParams.set("section_id", sectionId);
    url.searchParams.set("_summer_shelf_refresh", "20260805");

    fetch(url.toString(), {
      credentials: "same-origin",
      headers: {
        Accept: "text/html",
        "cache-control": "no-cache",
        pragma: "no-cache"
      }
    })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(function (html) {
        insertShelf(html, anchor, existing);
        anchor.dataset.summerShelfRefresh = "done";
      })
      .catch(function () {
        anchor.dataset.summerShelfRefresh = "failed";
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshSummerShelf);
  } else {
    refreshSummerShelf();
  }
  window.addEventListener("pageshow", refreshSummerShelf);
})();
/* summer-recommended-app-shelf-flick30-20260805-v1:end */

/* summer-recommended-app-shelf-flick30-black-20260805-v1:start */
(function () {
  "use strict";

  var rawSectionId = "summer_recommended_fabrics_flick30_black";
  var legacySectionIds = ["summer_recommended_fabrics_home","summer_recommended_fabrics_flick","summer_recommended_fabrics_flick_30"];
  window.__summerRecommendedAppShelfRefresh = "summer-recommended-app-shelf-flick30-black-20260805-v1";
  var expectedTitle = "夏のおすすめ生地";
  var expectedLink = "/collections/summer-recommended-fabrics";

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function hasCurrentShelf(node) {
    if (!node) return false;
    var text = node.textContent || "";
    return text.indexOf(expectedTitle) !== -1 && node.innerHTML.indexOf(expectedLink) !== -1;
  }

  function buildSectionIdFromAnchor(anchor) {
    if (!anchor || !anchor.id) return "";
    var id = anchor.id.replace(/^shopify-section-/, "");
    if (id.indexOf("__new_arrivals_top") === -1) return "";
    return id.replace(/__new_arrivals_top$/, "__" + rawSectionId);
  }

  function removeLegacyShelves(current) {
    legacySectionIds.forEach(function (legacyId) {
      var legacy = document.querySelector('[id$="__' + legacyId + '"]');
      if (legacy && legacy !== current) legacy.remove();
    });
  }

  function insertShelf(html, anchor, existing) {
    if (!html || html.indexOf(expectedTitle) === -1 || html.indexOf(expectedLink) === -1) return;

    var template = document.createElement("template");
    template.innerHTML = html.trim();
    var section = template.content.firstElementChild;
    if (!section) return;

    if (existing) existing.replaceWith(section);
    else anchor.parentNode.insertBefore(section, anchor);
    removeLegacyShelves(section);
  }

  function refreshSummerShelf() {
    if (!isHome() || !window.fetch) return;

    var existing = document.querySelector('[id$="__' + rawSectionId + '"]');
    if (hasCurrentShelf(existing)) {
      removeLegacyShelves(existing);
      return;
    }

    var anchor = document.querySelector('[id$="__new_arrivals_top"]');
    if (!anchor || !anchor.parentNode || anchor.dataset.summerShelfRefresh === "loading") return;

    var sectionId = buildSectionIdFromAnchor(anchor);
    if (!sectionId) return;

    anchor.dataset.summerShelfRefresh = "loading";

    var url = new URL(window.location.href);
    url.search = "";
    url.searchParams.set("section_id", sectionId);
    url.searchParams.set("_summer_shelf_refresh", "20260805");

    fetch(url.toString(), {
      credentials: "same-origin",
      headers: {
        Accept: "text/html",
        "cache-control": "no-cache",
        pragma: "no-cache"
      }
    })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(function (html) {
        insertShelf(html, anchor, existing);
        anchor.dataset.summerShelfRefresh = "done";
      })
      .catch(function () {
        anchor.dataset.summerShelfRefresh = "failed";
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshSummerShelf);
  } else {
    refreshSummerShelf();
  }
  window.addEventListener("pageshow", refreshSummerShelf);
})();
/* summer-recommended-app-shelf-flick30-black-20260805-v1:end */

/* home-work-example-app-shelves-20260805-v1:start */
(function () {
  "use strict";

  var marker = "home-work-example-app-shelves-20260805-v1";
  var summerSectionId = "summer_recommended_fabrics_flick30_black_v2";
  var newsletterSectionId = "home_newsletter_signup_20260715";
  var sections = [{"rawId":"adult_work_examples_home_flick_20260805_v1","title":"大人服の作品例","link":"/blogs/work-examples/otona"},{"rawId":"kids_work_examples_home_flick_20260805_v1","title":"子供服の作品例","link":"/blogs/work-examples/kodomo"}];
  var attempts = 0;
  window.__homeWorkExampleShelvesRefresh = marker;

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function byRawId(rawId) {
    return document.querySelector('[id$="__' + rawId + '"]');
  }

  function validSection(node, spec) {
    if (!node) return false;
    var html = node.innerHTML || "";
    var text = node.textContent || "";
    return text.indexOf(spec.title) !== -1 && html.indexOf(spec.link) !== -1 && html.indexOf("Liquid error") === -1;
  }

  function templatePrefix() {
    var candidates = [byRawId(summerSectionId), byRawId(newsletterSectionId), document.querySelector('[id^="shopify-section-template--"]')];
    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node || !node.id) continue;
      var id = node.id.replace(/^shopify-section-/, "");
      var index = id.lastIndexOf("__");
      if (index >= 0) return id.slice(0, index + 2);
    }
    return "";
  }

  function parseSection(html, spec) {
    if (!html || html.indexOf(spec.title) === -1 || html.indexOf(spec.link) === -1 || html.indexOf("Liquid error") !== -1) return null;
    var template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  }

  function placeInOrder() {
    var summer = byRawId(summerSectionId);
    var newsletter = byRawId(newsletterSectionId);
    var adult = byRawId(sections[0].rawId);
    var kids = byRawId(sections[1].rawId);

    if (summer && adult) summer.insertAdjacentElement("afterend", adult);
    if (adult && kids) adult.insertAdjacentElement("afterend", kids);
    if (!summer && newsletter) {
      if (adult && adult.nextElementSibling !== kids) newsletter.parentNode.insertBefore(adult, newsletter);
      if (kids) newsletter.parentNode.insertBefore(kids, newsletter);
    }
  }

  function insertSection(html, spec) {
    var section = parseSection(html, spec);
    if (!section) return;

    var existing = byRawId(spec.rawId);
    if (existing) existing.replaceWith(section);
    else {
      var newsletter = byRawId(newsletterSectionId);
      if (!newsletter || !newsletter.parentNode) return;
      newsletter.parentNode.insertBefore(section, newsletter);
    }
  }

  function refreshWorkShelves() {
    if (!isHome() || !window.fetch) return;

    if (!byRawId(summerSectionId) && attempts < 8) {
      attempts += 1;
      window.setTimeout(refreshWorkShelves, 250);
      return;
    }

    var prefix = templatePrefix();
    if (!prefix) return;

    var pending = sections.filter(function (spec) {
      return !validSection(byRawId(spec.rawId), spec);
    });

    if (!pending.length) {
      placeInOrder();
      return;
    }

    Promise.all(pending.map(function (spec) {
      var url = new URL(window.location.href);
      url.search = "";
      url.searchParams.set("section_id", prefix + spec.rawId);
      url.searchParams.set("_work_shelf_refresh", "20260805");
      return fetch(url.toString(), {
        credentials: "same-origin",
        headers: {
          Accept: "text/html",
          "cache-control": "no-cache",
          pragma: "no-cache"
        }
      })
        .then(function (response) {
          return response.ok ? response.text() : "";
        })
        .then(function (html) {
          insertSection(html, spec);
        });
    }))
      .then(placeInOrder)
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshWorkShelves);
  } else {
    refreshWorkShelves();
  }
  window.addEventListener("pageshow", refreshWorkShelves);
  window.setTimeout(refreshWorkShelves, 1500);
})();
/* home-work-example-app-shelves-20260805-v1:end */

/* home-work-example-app-shelves-20260805-v2:start */
(function () {
  "use strict";

  var marker = "home-work-example-app-shelves-20260805-v2";
  var summerSectionId = "summer_recommended_fabrics_flick30_black_v2";
  var newsletterSectionId = "home_newsletter_signup_20260715";
  var sections = [{"rawId":"adult_work_examples_home_flick_20260805_v2","title":"大人服の作品例","link":"/blogs/work-examples/otona"},{"rawId":"kids_work_examples_home_flick_20260805_v2","title":"子供服の作品例","link":"/blogs/work-examples/kodomo"}];
  var attempts = 0;
  window.__homeWorkExampleShelvesRefresh = marker;

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function byRawId(rawId) {
    return document.querySelector('[id$="__' + rawId + '"]');
  }

  function validSection(node, spec) {
    if (!node) return false;
    var html = node.innerHTML || "";
    var text = node.textContent || "";
    return text.indexOf(spec.title) !== -1 && html.indexOf(spec.link) !== -1 && html.indexOf("Liquid error") === -1;
  }

  function templatePrefix() {
    var candidates = [byRawId(summerSectionId), byRawId(newsletterSectionId), document.querySelector('[id^="shopify-section-template--"]')];
    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node || !node.id) continue;
      var id = node.id.replace(/^shopify-section-/, "");
      var index = id.lastIndexOf("__");
      if (index >= 0) return id.slice(0, index + 2);
    }
    return "";
  }

  function parseSection(html, spec) {
    if (!html || html.indexOf(spec.title) === -1 || html.indexOf(spec.link) === -1 || html.indexOf("Liquid error") !== -1) return null;
    var template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  }

  function placeInOrder() {
    var summer = byRawId(summerSectionId);
    var newsletter = byRawId(newsletterSectionId);
    var adult = byRawId(sections[0].rawId);
    var kids = byRawId(sections[1].rawId);

    if (summer && adult) summer.insertAdjacentElement("afterend", adult);
    if (adult && kids) adult.insertAdjacentElement("afterend", kids);
    if (!summer && newsletter) {
      if (adult && adult.nextElementSibling !== kids) newsletter.parentNode.insertBefore(adult, newsletter);
      if (kids) newsletter.parentNode.insertBefore(kids, newsletter);
    }
  }

  function insertSection(html, spec) {
    var section = parseSection(html, spec);
    if (!section) return;

    var existing = byRawId(spec.rawId);
    if (existing) existing.replaceWith(section);
    else {
      var newsletter = byRawId(newsletterSectionId);
      if (!newsletter || !newsletter.parentNode) return;
      newsletter.parentNode.insertBefore(section, newsletter);
    }
  }

  function refreshWorkShelves() {
    if (!isHome() || !window.fetch) return;

    if (!byRawId(summerSectionId) && attempts < 8) {
      attempts += 1;
      window.setTimeout(refreshWorkShelves, 250);
      return;
    }

    var prefix = templatePrefix();
    if (!prefix) return;

    var pending = sections.filter(function (spec) {
      return !validSection(byRawId(spec.rawId), spec);
    });

    if (!pending.length) {
      placeInOrder();
      return;
    }

    Promise.all(pending.map(function (spec) {
      var url = new URL(window.location.href);
      url.search = "";
      url.searchParams.set("section_id", prefix + spec.rawId);
      url.searchParams.set("_work_shelf_refresh", "20260805");
      return fetch(url.toString(), {
        credentials: "same-origin",
        headers: {
          Accept: "text/html",
          "cache-control": "no-cache",
          pragma: "no-cache"
        }
      })
        .then(function (response) {
          return response.ok ? response.text() : "";
        })
        .then(function (html) {
          insertSection(html, spec);
        });
    }))
      .then(placeInOrder)
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshWorkShelves);
  } else {
    refreshWorkShelves();
  }
  window.addEventListener("pageshow", refreshWorkShelves);
  window.setTimeout(refreshWorkShelves, 1500);
})();
/* home-work-example-app-shelves-20260805-v2:end */

/* home-work-example-app-shelves-20260806-v3:start */
(function () {
  "use strict";

  var marker = "home-work-example-app-shelves-20260806-v3";
  var summerSectionId = "summer_recommended_fabrics_flick30_black_v2";
  var newsletterSectionId = "home_newsletter_signup_20260715";
  var sections = [{"rawId":"adult_work_examples_home_flick_20260806_v3","title":"大人服の作品例","link":"/blogs/work-examples/otona"},{"rawId":"kids_work_examples_home_flick_20260806_v3","title":"子供服の作品例","link":"/blogs/work-examples/kodomo"}];
  var attempts = 0;
  window.__homeWorkExampleShelvesRefresh = marker;

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function byRawId(rawId) {
    return document.querySelector('[id$="__' + rawId + '"]');
  }

  function validSection(node, spec) {
    if (!node) return false;
    var html = node.innerHTML || "";
    var text = node.textContent || "";
    return text.indexOf(spec.title) !== -1 && html.indexOf(spec.link) !== -1 && html.indexOf("Liquid error") === -1;
  }

  function templatePrefix() {
    var candidates = [byRawId(summerSectionId), byRawId(newsletterSectionId), document.querySelector('[id^="shopify-section-template--"]')];
    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node || !node.id) continue;
      var id = node.id.replace(/^shopify-section-/, "");
      var index = id.lastIndexOf("__");
      if (index >= 0) return id.slice(0, index + 2);
    }
    return "";
  }

  function parseSection(html, spec) {
    if (!html || html.indexOf(spec.title) === -1 || html.indexOf(spec.link) === -1 || html.indexOf("Liquid error") !== -1) return null;
    var template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  }

  function placeInOrder() {
    var summer = byRawId(summerSectionId);
    var newsletter = byRawId(newsletterSectionId);
    var adult = byRawId(sections[0].rawId);
    var kids = byRawId(sections[1].rawId);

    if (summer && adult) summer.insertAdjacentElement("afterend", adult);
    if (adult && kids) adult.insertAdjacentElement("afterend", kids);
    if (!summer && newsletter) {
      if (adult && adult.nextElementSibling !== kids) newsletter.parentNode.insertBefore(adult, newsletter);
      if (kids) newsletter.parentNode.insertBefore(kids, newsletter);
    }
  }

  function insertSection(html, spec) {
    var section = parseSection(html, spec);
    if (!section) return;

    var existing = byRawId(spec.rawId);
    if (existing) existing.replaceWith(section);
    else {
      var newsletter = byRawId(newsletterSectionId);
      if (!newsletter || !newsletter.parentNode) return;
      newsletter.parentNode.insertBefore(section, newsletter);
    }
  }

  function refreshWorkShelves() {
    if (!isHome() || !window.fetch) return;

    if (!byRawId(summerSectionId) && attempts < 8) {
      attempts += 1;
      window.setTimeout(refreshWorkShelves, 250);
      return;
    }

    var prefix = templatePrefix();
    if (!prefix) return;

    var pending = sections.filter(function (spec) {
      return !validSection(byRawId(spec.rawId), spec);
    });

    if (!pending.length) {
      placeInOrder();
      return;
    }

    Promise.all(pending.map(function (spec) {
      var url = new URL(window.location.href);
      url.search = "";
      url.searchParams.set("section_id", prefix + spec.rawId);
      url.searchParams.set("_work_shelf_refresh", "20260805");
      return fetch(url.toString(), {
        credentials: "same-origin",
        headers: {
          Accept: "text/html",
          "cache-control": "no-cache",
          pragma: "no-cache"
        }
      })
        .then(function (response) {
          return response.ok ? response.text() : "";
        })
        .then(function (html) {
          insertSection(html, spec);
        });
    }))
      .then(placeInOrder)
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshWorkShelves);
  } else {
    refreshWorkShelves();
  }
  window.addEventListener("pageshow", refreshWorkShelves);
  window.setTimeout(refreshWorkShelves, 1500);
})();
/* home-work-example-app-shelves-20260806-v3:end */

/* summer-recommended-app-shelf-flick30-black-v2-20260805:start */
(function () {
  "use strict";

  var rawSectionId = "summer_recommended_fabrics_flick30_black_v2";
  var preferredAnchorSectionId = "adult_work_examples_home_flick_20260806_v4";
  var anchorSectionId = "home_newsletter_signup_20260715";
  var legacySectionIds = ["summer_recommended_fabrics_home","summer_recommended_fabrics_flick","summer_recommended_fabrics_flick_30","summer_recommended_fabrics_flick30_black"];
  window.__summerRecommendedAppShelfRefresh = "summer-recommended-app-shelf-flick30-black-v2-20260805";
  var expectedTitle = "夏のおすすめ生地";
  var expectedLink = "/collections/summer-recommended-fabrics";

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function hasCurrentShelf(node) {
    if (!node) return false;
    var text = node.textContent || "";
    return text.indexOf(expectedTitle) !== -1 && node.innerHTML.indexOf(expectedLink) !== -1;
  }

  function buildSectionIdFromAnchor(anchor, rawAnchorId) {
    if (!anchor || !anchor.id) return "";
    var id = anchor.id.replace(/^shopify-section-/, "");
    var suffix = "__" + rawAnchorId;
    if (id.slice(-suffix.length) !== suffix) return "";
    return id.slice(0, -rawAnchorId.length) + rawSectionId;
  }

  function removeLegacyShelves(current) {
    legacySectionIds.forEach(function (legacyId) {
      var legacy = document.querySelector('[id$="__' + legacyId + '"]');
      if (legacy && legacy !== current) legacy.remove();
    });
  }

  function insertShelf(html, anchor, existing) {
    if (!html || html.indexOf(expectedTitle) === -1 || html.indexOf(expectedLink) === -1) return;

    var template = document.createElement("template");
    template.innerHTML = html.trim();
    var section = template.content.firstElementChild;
    if (!section) return;

    if (existing) existing.replaceWith(section);
    else anchor.parentNode.insertBefore(section, anchor);
    removeLegacyShelves(section);
  }

  function refreshSummerShelf() {
    if (!isHome() || !window.fetch) return;

    var existing = document.querySelector('[id$="__' + rawSectionId + '"]');
    if (hasCurrentShelf(existing)) {
      removeLegacyShelves(existing);
      return;
    }

    var anchor = document.querySelector('[id$="__' + preferredAnchorSectionId + '"]') || document.querySelector('[id$="__' + anchorSectionId + '"]');
    if (!anchor || !anchor.parentNode || anchor.dataset.summerShelfRefresh === "loading") return;

    var anchorRawId = anchor.id.slice(-("__" + preferredAnchorSectionId).length) === "__" + preferredAnchorSectionId ? preferredAnchorSectionId : anchorSectionId;
    var sectionId = buildSectionIdFromAnchor(anchor, anchorRawId);
    if (!sectionId) return;

    anchor.dataset.summerShelfRefresh = "loading";

    var url = new URL(window.location.href);
    url.search = "";
    url.searchParams.set("section_id", sectionId);
    url.searchParams.set("_summer_shelf_refresh", "20260805");

    fetch(url.toString(), {
      credentials: "same-origin",
      headers: {
        Accept: "text/html",
        "cache-control": "no-cache",
        pragma: "no-cache"
      }
    })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(function (html) {
        insertShelf(html, anchor, existing);
        anchor.dataset.summerShelfRefresh = "done";
      })
      .catch(function () {
        anchor.dataset.summerShelfRefresh = "failed";
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshSummerShelf);
  } else {
    refreshSummerShelf();
  }
  window.addEventListener("pageshow", refreshSummerShelf);
})();
/* summer-recommended-app-shelf-flick30-black-v2-20260805:end */

/* home-pc-sidebar-menu-20260806-v1:start */
(() => {
  const sectionId = "template--27265167622437__home_pc_sidebar_menu_20260806_v5";
  const sectionWrapperId = "shopify-section-" + sectionId;
  const anchorIds = [
    "shopify-section-template--27265167622437__slideshow_EjeR7H",
    "shopify-section-template--27265167622437__home_video_showcase_top",
    "shopify-section-template--27265167622437__new_arrivals_top",
    "shopify-section-template--27265167622437__summer_recommended_fabrics_flick30_black_v2"
  ];
  const syncedSelector = '[data-home-pc-sidebar-menu-sync="product-context-sidebar-v8"]';
  let pending = false;

  function shouldRun() {
    return location.pathname === "/" && window.matchMedia("(min-width: 1200px)").matches;
  }

  function currentSidebar() {
    return document.getElementById(sectionWrapperId)
      || document.querySelector("[data-home-pc-sidebar-menu]")?.closest(".shopify-section")
      || document.querySelector("[data-home-pc-sidebar-menu]");
  }

  function isSynced(node) {
    return Boolean(node && (node.matches?.(syncedSelector) || node.querySelector?.(syncedSelector)));
  }

  function firstAnchor() {
    for (const id of anchorIds) {
      const node = document.getElementById(id);
      if (node) return node;
    }
    return null;
  }

  function placeBeforeAnchor(node, anchor) {
    if (!node || !anchor) return false;
    if (node.nextElementSibling !== anchor) anchor.before(node);
    return true;
  }

  async function fetchSidebarSection() {
    try {
      const response = await fetch(location.origin + "/?sections=" + encodeURIComponent(sectionId), {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) return null;

      const sections = await response.json();
      const html = sections[sectionId];
      if (!html) return null;

      const template = document.createElement("template");
      template.innerHTML = html.trim();
      return template.content.firstElementChild || null;
    } catch (error) {
      console.warn("[home-pc-sidebar-menu] product context fallback failed", error);
      return null;
    }
  }

  async function ensureHomePcSidebar() {
    if (!shouldRun() || pending) return;
    const anchor = firstAnchor();
    if (!anchor) return;

    const existing = currentSidebar();
    if (isSynced(existing)) {
      placeBeforeAnchor(existing, anchor);
      return;
    }

    pending = true;
    try {
      const section = await fetchSidebarSection();
      if (!section) return;
      const current = currentSidebar();
      if (current) current.replaceWith(section);
      placeBeforeAnchor(section, anchor);
    } catch (error) {
      console.warn("[home-pc-sidebar-menu] product context fallback failed", error);
    } finally {
      pending = false;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureHomePcSidebar, { once: true });
  } else {
    ensureHomePcSidebar();
  }
  window.addEventListener("pageshow", ensureHomePcSidebar);
  window.matchMedia("(min-width: 1200px)").addEventListener?.("change", ensureHomePcSidebar);
})();
/* home-pc-sidebar-menu-20260806-v1:end */

/* mobile-variant-atc-prototype-20260725:start */
(function () {
  var MARKER = "mobile-variant-atc-prototype-20260725";
  if (window.__kijiMobileVariantAtcPrototype20260725) return;
  window.__kijiMobileVariantAtcPrototype20260725 = true;

  var path = window.location && window.location.pathname ? window.location.pathname.replace(/\/+$/, "") : "";
  var isProductPage = /^\/products\/[^/]+$/.test(path);

  var config = null;
  var state = {
    variantId: null,
    variantAxis1: null,
    lengthCm: null,
    quantityUnits: "1",
    cartCount: 0,
    nativeFormTouched: false,
    sheetSelectionTouched: false,
    busy: false
  };

  function yen(value) {
    return "¥" + Math.round(value).toLocaleString("ja-JP");
  }

  function normalizeText(value) {
    return String(value || "").replace(/\u3000/g, " ").replace(/\s+/g, " ").trim();
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[char];
    });
  }

  function metaContent(selector) {
    var node = document.querySelector(selector);
    return node ? normalizeText(node.getAttribute("content")) : "";
  }

  function typeList(node) {
    var type = node && node["@type"];
    if (Array.isArray(type)) return type;
    return type ? [type] : [];
  }

  function hasType(node, type) {
    return typeList(node).some(function (value) {
      return String(value).toLowerCase() === type.toLowerCase();
    });
  }

  function collectJsonLdNodes() {
    var nodes = [];
    function add(value) {
      if (!value) return;
      if (Array.isArray(value)) {
        value.forEach(add);
        return;
      }
      if (typeof value !== "object") return;
      nodes.push(value);
      if (Array.isArray(value["@graph"])) value["@graph"].forEach(add);
    }
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
      try {
        add(JSON.parse(script.textContent || "{}"));
      } catch (error) {}
    });
    return nodes;
  }

  function firstOffer(node) {
    var offer = node && node.offers;
    if (Array.isArray(offer)) return offer[0] || null;
    if (offer && Array.isArray(offer.offers)) return offer.offers[0] || offer;
    return offer || null;
  }

  function parseMoney(value, centsLikely) {
    if (value == null || value === "") return null;
    var number = typeof value === "number" ? value : Number(String(value).replace(/[^0-9.]/g, ""));
    if (!Number.isFinite(number)) return null;
    return centsLikely ? number / 100 : number;
  }

  function priceFromOffer(offer) {
    if (!offer) return null;
    return parseMoney(offer.price || offer.lowPrice || offer.highPrice, false);
  }

  function priceFromPage() {
    var selectors = [
      "[data-product-price]",
      ".price-list .money",
      ".product-info__price .money",
      ".product-meta__price-list .money",
      ".product-form__price .money",
      "[class*='price'] .money"
    ];
    for (var i = 0; i < selectors.length; i += 1) {
      var node = document.querySelector(selectors[i]);
      var price = parseMoney(node ? node.textContent : "", false);
      if (price != null) return price;
    }
    return null;
  }

  function availableFromOffer(offer) {
    var value = String((offer && offer.availability) || "");
    return !/(OutOfStock|SoldOut|Discontinued)/i.test(value);
  }

  function variantIdFromUrl(value) {
    if (!value) return "";
    try {
      return new URL(String(value), window.location.origin).searchParams.get("variant") || "";
    } catch (error) {
      var match = String(value).match(/[?&]variant=(\d+)/);
      return match ? match[1] : "";
    }
  }

  function currentFormVariantId() {
    var selectors = [
      'form[action*="/cart/add"] [name="id"]',
      'form[action*="/cart/add"] [name="id[]"]',
      '[name="id"]'
    ];
    for (var i = 0; i < selectors.length; i += 1) {
      var node = document.querySelector(selectors[i]);
      if (node && node.value) return String(node.value);
    }
    return variantIdFromUrl(window.location.href);
  }

  function stripProductTitle(name, productTitle) {
    var value = normalizeText(name);
    var title = normalizeText(productTitle);
    if (!value) return "通常";
    if (title && value.indexOf(title + " - ") === 0) return normalizeText(value.slice(title.length + 3));
    if (title && value.indexOf(title + " – ") === 0) return normalizeText(value.slice(title.length + 3));
    if (title && value.indexOf(title + "｜") === 0) return normalizeText(value.slice(title.length + 1));
    if (/^default title$/i.test(value)) return "通常";
    return value;
  }

  function imageFrom(value) {
    var src = Array.isArray(value) ? value[0] : value;
    if (src && typeof src === "object") src = src.url || src.src || "";
    src = String(src || "");
    if (!src) return "";
    try {
      var url = new URL(src, window.location.origin);
      if (!url.searchParams.has("width")) url.searchParams.set("width", "240");
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function sheetPreviewImageUrl(value) {
    var src = String(value || "");
    if (!src) return "";
    try {
      var url = new URL(src, window.location.origin);
      var isShopifyCdn = url.hostname === "cdn.shopify.com";
      var isStoreCdnPath = url.origin === window.location.origin && url.pathname.indexOf("/cdn/shop/") === 0;
      if (!isShopifyCdn && !isStoreCdnPath) return src;
      url.searchParams.set("width", "320");
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function dedupeVariants(variants) {
    var seen = {};
    return variants.filter(function (variant) {
      if (!variant || !variant.id || seen[variant.id]) return false;
      seen[variant.id] = true;
      return true;
    });
  }

  function readInventoryMap() {
    var script = document.querySelector('script[data-kiji-product-inventory]');
    if (!script) return {};
    try {
      var json = JSON.parse(script.textContent || "{}");
      var items = Array.isArray(json.variants) ? json.variants : [];
      return items.reduce(function (map, item) {
        if (!item || !item.id) return map;
        map[String(item.id)] = item;
        return map;
      }, {});
    } catch (error) {
      return {};
    }
  }

  function readSellingUnitData() {
    var script = document.querySelector('script[data-kiji-product-selling-unit]');
    if (!script) return { _present: false };
    try {
      var json = JSON.parse(script.textContent || "{}");
      json._present = true;
      return json;
    } catch (error) {
      return { _present: true };
    }
  }

  function positiveNumber(value) {
    if (value == null || value === "") return null;
    var number = Number(String(value).replace(/[^0-9.]/g, ""));
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function labelFromStepCm(stepCm) {
    if (stepCm >= 100 && stepCm % 100 === 0) return String(stepCm / 100) + "m";
    return String(stepCm) + "cm";
  }

  function lengthSellingConfig(stepCm, rawUnit, data) {
    var label = normalizeText(data && data.sellingUnitLabel) || labelFromStepCm(stepCm);
    if (/^(m|meter|metre|cm)$/i.test(label)) label = labelFromStepCm(stepCm);
    var maxSelectUnits = Math.max(1, Math.floor(positiveNumber(data && data.maxSelectCount) || 50));
    return {
      mode: "length",
      quantityUnit: rawUnit || "",
      stepCm: stepCm,
      unitLabel: label,
      maxSelectUnits: maxSelectUnits,
      priceSuffix: "（税込 / " + label + "）"
    };
  }

  function quantitySellingConfig(rawUnit, data) {
    var maxSelectUnits = Math.max(1, Math.floor(positiveNumber(data && data.maxSelectCount) || 50));
    return {
      mode: "quantity",
      quantityUnit: rawUnit || "",
      stepCm: 0,
      unitLabel: normalizeText(data && data.sellingUnitLabel) || "個",
      maxSelectUnits: maxSelectUnits,
      priceSuffix: "（税込）"
    };
  }

  function sellingConfigFromData(data, title) {
    data = data || { _present: false };
    var legacyUnit = normalizeText(data.legacySaleUnit || "");
    var rawUnit = normalizeText(data.quantityUnit || data.sellingMode || legacyUnit || "");
    if (!data.sellingUnitLabel && legacyUnit) data.sellingUnitLabel = legacyUnit;
    var unit = rawUnit.toLowerCase().replace(/[\s_\-]/g, "");
    var explicitStepCm = positiveNumber(data.sellingStepCm);
    if (explicitStepCm) return lengthSellingConfig(Math.round(explicitStepCm), rawUnit, data);

    var cmMatch = unit.match(/^cm(\d+)$/) || unit.match(/^(\d+)cm$/);
    if (cmMatch) return lengthSellingConfig(Number(cmMatch[1]), rawUnit, data);

    var meterMatch = unit.match(/^m(\d+(?:\.\d+)?)$/) || unit.match(/^(\d+(?:\.\d+)?)m$/);
    if (meterMatch) return lengthSellingConfig(Math.round(Number(meterMatch[1]) * 100), rawUnit, data);

    if (/^(cm50|50|50cm|0\.5m|halfmeter)$/.test(unit)) return lengthSellingConfig(50, rawUnit, data);
    if (/^(m|m1|1m|100cm|meter|metre)$/.test(unit)) return lengthSellingConfig(100, rawUnit, data);
    if (/^(m5|5m|500cm)$/.test(unit)) return lengthSellingConfig(500, rawUnit, data);
    if (/^(piece|pieces|quantity|qty|unit|each|pcs|set|sets|ko|個|個数|セット|枚|冊|本|件|型紙|pattern)$/.test(unit)) {
      return quantitySellingConfig(rawUnit, data);
    }

    if (!data._present && detectLengthProduct(title)) return lengthSellingConfig(50, rawUnit, data);
    return quantitySellingConfig(rawUnit, data);
  }

  function variantsFromProductGroup(productGroup, productTitle, fallbackImage, fallbackPrice) {
    var items = Array.isArray(productGroup && productGroup.hasVariant) ? productGroup.hasVariant : [];
    return dedupeVariants(items.map(function (item) {
      var offer = firstOffer(item);
      var id = variantIdFromUrl(item["@id"]) || variantIdFromUrl(item.url) || variantIdFromUrl(offer && offer.url);
      var price = priceFromOffer(offer);
      return {
        id: id ? String(id) : "",
        title: stripProductTitle(item.name || item.sku || item.mpn || "", productTitle),
        price: price != null ? price : fallbackPrice,
        available: availableFromOffer(offer),
        image: imageFrom(item.image) || fallbackImage
      };
    })).filter(function (variant) {
      return variant.id && variant.price != null;
    });
  }

  function variantsFromShopifyAnalytics(productTitle, fallbackImage, fallbackPrice) {
    var product = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    return dedupeVariants(variants.map(function (variant) {
      var price = parseMoney(variant.price, true);
      return {
        id: variant.id ? String(variant.id) : "",
        title: stripProductTitle(variant.public_title || variant.name || variant.title || variant.sku || "", productTitle),
        price: price != null ? price : fallbackPrice,
        available: variant.available !== false,
        image: imageFrom(variant.featured_image && (variant.featured_image.src || variant.featured_image.url)) || fallbackImage
      };
    })).filter(function (variant) {
      return variant.id && variant.price != null;
    });
  }

  function variantsFromForm(productTitle, fallbackImage, fallbackPrice) {
    var variants = [];
    var select = document.querySelector('form[action*="/cart/add"] select[name="id"], select[name="id"]');
    if (select) {
      Array.from(select.options || []).forEach(function (option) {
        var price = parseMoney(option.getAttribute("data-price"), true);
        variants.push({
          id: option.value ? String(option.value) : "",
          title: stripProductTitle(option.textContent || "", productTitle),
          price: price != null ? price : fallbackPrice,
          available: !option.disabled,
          image: fallbackImage
        });
      });
    }

    if (!variants.length) {
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[name="id"]').forEach(function (input) {
        variants.push({
          id: input.value ? String(input.value) : "",
          title: "通常",
          price: fallbackPrice,
          available: !input.disabled,
          image: fallbackImage
        });
      });
    }

    return dedupeVariants(variants).filter(function (variant) {
      return variant.id && variant.price != null;
    });
  }

  function detectLengthProduct(title) {
    var hasQuantityLengthSelect = Array.from(document.querySelectorAll('select[name="quantity"]')).some(function (select) {
      return Array.from(select.options || []).some(function (option) {
        return /50\s*cm|2500\s*cm|25\.0m/.test(normalizeText(option.textContent));
      });
    });
    var bodyText = normalizeText(document.body ? document.body.textContent : "").slice(0, 160000);
    var hasLengthEvidence = /(税込\s*\/\s*50\s*cm|\/\s*50\s*cm|50\s*cm単位|50cm単位|50cmから|50\s*cmから|50cmつなげて|50cm繋げて)/i.test(bodyText);
    var excludedByTitle = /(サンプル|サンプル帳|サンプルブック|型紙|パターン|書籍|本|はさみ|ハサミ|鋏|カタログ|キット|セット)/.test(title);
    return (hasQuantityLengthSelect || hasLengthEvidence) && !excludedByTitle;
  }

  function detectVariantLabel(variants) {
    var titles = variants.map(function (variant) { return variant.title; }).join(" ");
    if (/#\d+|カラー|色|ホワイト|オフ白|生成|グレー|ブラック|ネイビー|ブルー|ピンク|レッド|イエロー|グリーン|ベージュ|ブラウン/.test(titles)) {
      return "カラー:";
    }
    return "バリエーション:";
  }

  function splitVariantAxes(title) {
    var parts = normalizeText(title).split(/\s*\/\s*/).filter(Boolean);
    if (parts.length < 2) return null;
    return {
      axis1: parts[0],
      axis2: parts.slice(1).join(" / ")
    };
  }

  function uniqueValues(values) {
    var seen = {};
    return values.filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function detectStepwiseVariantAxes(variants) {
    var parsed = variants.map(function (variant) {
      var axes = splitVariantAxes(variant.title);
      return axes ? {
        id: String(variant.id),
        axis1: axes.axis1,
        axis2: axes.axis2
      } : null;
    }).filter(Boolean);
    if (parsed.length < Math.max(6, Math.floor(variants.length * 0.8))) return null;

    var axis1Values = uniqueValues(parsed.map(function (item) { return item.axis1; }));
    var axis2Values = uniqueValues(parsed.map(function (item) { return item.axis2; }));
    var looksLikePatternSize = axis1Values.some(function (value) {
      return /(\d+(?:\.\d+)?\s*(?:mm|ミリ)|柄\s*サイズ|チェック幅)/i.test(value);
    });
    var looksLikeColor = axis2Values.some(function (value) {
      return /#\d+|ホワイト|オフ白|生成|グレー|ブラック|ネイビー|ブルー|ピンク|レッド|イエロー|グリーン|ベージュ|ブラウン|ココア|カーキ|ラベンダー|ミント/.test(value);
    });

    if (axis1Values.length < 2 || axis1Values.length > 8 || axis2Values.length < 3 || !looksLikePatternSize || !looksLikeColor) {
      return null;
    }

    var map = {};
    parsed.forEach(function (item) {
      map[item.id] = item;
    });
    return {
      axis1Label: "柄サイズ",
      axis2Label: "カラー:",
      axis1Values: axis1Values,
      variantMap: map
    };
  }

  function collectProductConfig() {
    var nodes = collectJsonLdNodes();
    var productGroup = nodes.find(function (node) {
      return hasType(node, "ProductGroup") || Array.isArray(node.hasVariant);
    });
    var productNode = productGroup || nodes.find(function (node) {
      return hasType(node, "Product");
    }) || {};
    var title = normalizeText(
      productNode.name ||
      metaContent('meta[property="og:title"]') ||
      (document.querySelector("h1") && document.querySelector("h1").textContent) ||
      document.title
    );
    var fallbackImage = imageFrom(productNode.image) || imageFrom(metaContent('meta[property="og:image"]')) || "";
    var fallbackPrice = priceFromOffer(firstOffer(productNode));
    if (fallbackPrice == null) fallbackPrice = priceFromPage();
    var inventoryMap = readInventoryMap();
    var sellingUnitData = readSellingUnitData();
    var variants = [];

    if (productGroup) {
      variants = variantsFromProductGroup(productGroup, title, fallbackImage, fallbackPrice);
    }
    if (!variants.length) {
      variants = variantsFromShopifyAnalytics(title, fallbackImage, fallbackPrice);
    }
    if (!variants.length) {
      variants = variantsFromForm(title, fallbackImage, fallbackPrice);
    }
    if (!variants.length && currentFormVariantId() && fallbackPrice != null) {
      variants = [{
        id: currentFormVariantId(),
        title: "通常",
        price: fallbackPrice,
        available: true,
        image: fallbackImage
      }];
    }

    variants = dedupeVariants(variants).map(function (variant) {
      var inventory = inventoryMap[String(variant.id)] || {};
      var inventoryQuantity = inventory.inventoryQuantity;
      if (inventoryQuantity == null) inventoryQuantity = inventory.inventory_quantity;
      inventoryQuantity = inventoryQuantity == null || inventoryQuantity === "" ? null : Number(inventoryQuantity);
      return {
        id: String(variant.id),
        title: normalizeText(variant.title || "通常"),
        price: Number(variant.price),
        available: variant.available !== false,
        image: variant.image || fallbackImage,
        inventoryManagement: inventory.inventoryManagement || inventory.inventory_management || "",
        inventoryPolicy: inventory.inventoryPolicy || inventory.inventory_policy || "",
        inventoryQuantity: Number.isFinite(inventoryQuantity) ? inventoryQuantity : null
      };
    }).filter(function (variant) {
      return variant.id && Number.isFinite(variant.price);
    });

    if (!variants.length) return null;

    var variantAxes = detectStepwiseVariantAxes(variants);
    if (variantAxes) {
      variants = variants.map(function (variant) {
        var axes = variantAxes.variantMap[String(variant.id)];
        return {
          id: variant.id,
          title: variant.title,
          price: variant.price,
          available: variant.available,
          image: variant.image,
          inventoryManagement: variant.inventoryManagement,
          inventoryPolicy: variant.inventoryPolicy,
          inventoryQuantity: variant.inventoryQuantity,
          axis1: axes ? axes.axis1 : "",
          axis2: axes ? axes.axis2 : variant.title
        };
      });
    }

    var availablePrices = variants.filter(function (variant) { return variant.available; }).map(function (variant) { return variant.price; });
    var prices = availablePrices.length ? availablePrices : variants.map(function (variant) { return variant.price; });
    var selling = sellingConfigFromData(sellingUnitData, title);
    var usesLength = selling.mode === "length";
    return {
      title: title,
      image: fallbackImage || variants[0].image || "",
      minPrice: Math.min.apply(null, prices),
      variants: variants,
      usesLength: usesLength,
      sellingMode: selling.mode,
      quantityUnit: selling.quantityUnit,
      stepCm: selling.stepCm,
      unitLabel: selling.unitLabel,
      maxSelectUnits: selling.maxSelectUnits,
      purchaseFieldLabel: usesLength ? "長さ" : "数量",
      variantLabel: detectVariantLabel(variants),
      variantAxes: variantAxes,
      priceSuffix: selling.priceSuffix
    };
  }

  function selectedVariant() {
    return config.variants.find(function (variant) {
      return String(variant.id) === String(state.variantId);
    }) || null;
  }

  function variantsForCurrentAxis() {
    if (!config.variantAxes) return config.variants;
    if (!state.variantAxis1) return [];
    return config.variants.filter(function (variant) {
      return variant.axis1 === state.variantAxis1;
    });
  }

  function previewVariantForCurrentAxis() {
    var variants = variantsForCurrentAxis();
    return variants.find(function (variant) { return variant.available; }) || variants[0] || null;
  }

  function variantPlaceholderText() {
    var label = config.variantAxes ? config.variantAxes.axis2Label : config.variantLabel;
    return label.replace(/[：:]\s*$/, "") + "を選択";
  }

  function clearOptions(select) {
    while (select && select.firstChild) select.removeChild(select.firstChild);
  }

  function optionLabelForVariant(variant) {
    return (config.variantAxes ? (variant.axis2 || variant.title) : variant.title) + (variant.available ? "" : "（在庫なし）");
  }

  function populateVariantOptions(select) {
    if (!select || !config) return;
    if (path === "/products/4500") {
      var optionsKey = String(state.variantAxis1 || "") + ":" + config.variants.length;
      if (select.dataset.m4500Options === optionsKey) return;
      select.dataset.m4500Options = optionsKey;
    }
    clearOptions(select);
    if (config.variantAxes && !state.variantAxis1) {
      select.appendChild(new Option("先に柄サイズを選択", ""));
      select.disabled = true;
      return;
    }
    select.disabled = false;
    select.appendChild(new Option(variantPlaceholderText(), ""));
    variantsForCurrentAxis().forEach(function (variant) {
      var option = new Option(optionLabelForVariant(variant), String(variant.id));
      option.disabled = !variant.available;
      select.appendChild(option);
    });
  }

  function lengthUnits() {
    if (!config.usesLength) {
      var quantityUnits = Number(state.quantityUnits || 1);
      return Number.isFinite(quantityUnits) && quantityUnits > 0 ? quantityUnits : 0;
    }
    var stepCm = config.stepCm || 50;
    return state.lengthCm ? Number(state.lengthCm) / stepCm : 0;
  }

  function totalPrice() {
    var variant = selectedVariant();
    var units = lengthUnits();
    if (!variant || !units) return null;
    return variant.price * units;
  }

  function buildLengths() {
    var lengths = [];
    var stepCm = config && config.stepCm ? config.stepCm : 50;
    for (var units = 1; units <= 50; units += 1) lengths.push(units * stepCm);
    return lengths;
  }

  function variantMaxUnits(variant) {
    if (!variant) return null;
    if (!variant.inventoryManagement || variant.inventoryPolicy !== "deny") return null;
    if (variant.inventoryQuantity == null || !Number.isFinite(Number(variant.inventoryQuantity))) return null;
    return Math.max(0, Math.floor(Number(variant.inventoryQuantity)));
  }

  function lengthLabel(cm) {
    var stepCm = config && config.stepCm ? config.stepCm : 50;
    if (stepCm >= 100 && stepCm % 100 === 0) return String(cm / 100) + "m";
    return cm >= 100 ? cm + " cm（" + (cm / 100).toFixed(1) + "m）" : cm + " cm";
  }

  function stockLengthMessage(variant) {
    if (!config || !variant) return "";
    var maxUnits = variantMaxUnits(variant);
    if (maxUnits == null) return "";
    if (maxUnits <= 0) return "このカラーは現在在庫がありません。再入荷や代替色はLINEでご相談ください。";
    var selectCap = config.maxSelectUnits || 50;
    if (!config.usesLength) {
      if (maxUnits >= Math.min(selectCap, 10)) return "";
      return "現在この種類は数量" + maxUnits + "点のみご購入いただけます。必要数が足りない場合はLINEでご相談ください。";
    }
    var maxCm = maxUnits * (config.stepCm || 50);
    if (maxCm >= 2500) return "";
    return "現在このカラーは" + lengthLabel(maxCm) + "分のみご購入いただけます。必要な長さが足りない場合はLINEでご相談ください。";
  }

  function populateLengthOptions(select) {
    if (!select || !config) return;
    var variant = selectedVariant();
    if (path === "/products/4500" && variant) {
      var lengthOptionsKey = String(variant.id) + ":" + variantMaxUnits(variant) + ":" + (config.maxSelectUnits || 50);
      if (select.dataset.m4500Options === lengthOptionsKey) return;
      select.dataset.m4500Options = lengthOptionsKey;
    } else { delete select.dataset.m4500Options; }
    clearOptions(select);

    if (config.variants.length > 1 && !variant) {
      select.appendChild(new Option(config.usesLength ? "先にカラーを選択" : "先に種類を選択", ""));
      select.disabled = true;
      return;
    }

    var maxUnits = variantMaxUnits(variant);
    if (maxUnits === 0) {
      select.appendChild(new Option("在庫がありません", ""));
      select.disabled = true;
      state.lengthCm = null;
      state.quantityUnits = null;
      return;
    }

    var selectCap = config.maxSelectUnits || 50;
    var selectableUnits = maxUnits == null ? selectCap : Math.min(selectCap, maxUnits);
    select.disabled = false;
    if (config.usesLength) {
      select.appendChild(new Option("長さを選択", ""));
      var stepCm = config.stepCm || 50;
      for (var units = 1; units <= selectableUnits; units += 1) {
        var cm = units * stepCm;
        select.appendChild(new Option(lengthLabel(cm), String(cm)));
      }
      if (state.lengthCm && Number(state.lengthCm) > selectableUnits * stepCm) state.lengthCm = null;
      return;
    }

    for (var quantity = 1; quantity <= selectableUnits; quantity += 1) {
      select.appendChild(new Option(String(quantity), String(quantity)));
    }
    if (!state.quantityUnits || Number(state.quantityUnits) > selectableUnits) state.quantityUnits = "1";
  }

  function setToast(message) {
    var toast = document.querySelector(".kiji-mobile-atc__toast");
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(setToast.timer);
    setToast.timer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 1800);
  }

  function ensureSheet() {
    if (document.querySelector(".kiji-mobile-atc__sheet")) return true;
    if (!config) return false;

    try {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = [
        '<div class="kiji-mobile-atc__backdrop"></div>',
        '<section class="kiji-mobile-atc__sheet" role="dialog" aria-modal="true" aria-hidden="true" aria-labelledby="kijiMobileAtcTitle">',
        '  <header class="kiji-mobile-atc__sheet-header">',
        '    <button class="kiji-mobile-atc__close" type="button">閉じる</button>',
        '    <h2 class="kiji-mobile-atc__title" id="kijiMobileAtcTitle">商品詳細を選択</h2>',
        "    <span></span>",
        "  </header>",
        '  <div class="kiji-mobile-atc__content">',
        '    <article class="kiji-mobile-atc__product">',
        '      <img alt="" loading="eager">',
        "      <div>",
        '        <p class="kiji-mobile-atc__product-title">' + escapeHtml(config.title) + "</p>",
        '        <div class="kiji-mobile-atc__product-price">' + yen(config.minPrice).replace("¥", "") + "円〜<small>" + escapeHtml(config.priceSuffix) + "</small></div>",
        "      </div>",
        "    </article>",
        '    <div class="kiji-mobile-atc__form-card">',
        '      <div class="kiji-mobile-atc__field" data-kiji-axis1-field>',
        '        <label for="kijiMobileAtcAxis1">' + escapeHtml(config.variantAxes ? config.variantAxes.axis1Label : "種類") + "</label>",
        '        <div class="kiji-mobile-atc__select-wrap"><select class="kiji-mobile-atc__select" id="kijiMobileAtcAxis1"></select></div>',
        "      </div>",
        '      <div class="kiji-mobile-atc__field" data-kiji-variant-field>',
        '        <label for="kijiMobileAtcVariant">' + escapeHtml(config.variantAxes ? config.variantAxes.axis2Label : config.variantLabel) + "</label>",
        '        <div class="kiji-mobile-atc__select-wrap"><select class="kiji-mobile-atc__select" id="kijiMobileAtcVariant"></select></div>',
        "      </div>",
        '      <div class="kiji-mobile-atc__field" data-kiji-length-field>',
        '        <label for="kijiMobileAtcLength">' + escapeHtml(config.purchaseFieldLabel || (config.usesLength ? "長さ" : "数量")) + "</label>",
        '        <div class="kiji-mobile-atc__select-wrap"><select class="kiji-mobile-atc__select" id="kijiMobileAtcLength"></select></div>',
        "      </div>",
        '      <div class="kiji-mobile-atc__total" aria-live="polite"><span>合計</span><strong>' + yen(config.minPrice) + '〜</strong><span>（税込）</span></div>',
        '      <p class="kiji-mobile-atc__stock-note" hidden></p>',
        "    </div>",
        "  </div>",
        '  <footer class="kiji-mobile-atc__sheet-footer">',
        '    <button class="kiji-mobile-atc__button" type="button" data-action="add">カートに追加</button>',
        '    <button class="kiji-mobile-atc__button" type="button" data-action="checkout">購入手続きへ</button>',
        "  </footer>",
        "</section>",
        '<div class="kiji-mobile-atc__toast" role="status" aria-live="polite"></div>'
      ].join("");

      while (wrapper.firstElementChild) document.body.appendChild(wrapper.firstElementChild);

      var axis1Select = document.querySelector("#kijiMobileAtcAxis1");
      var variantSelect = document.querySelector("#kijiMobileAtcVariant");
      var lengthSelect = document.querySelector("#kijiMobileAtcLength");
      var axis1Field = document.querySelector("[data-kiji-axis1-field]");
      var variantField = document.querySelector("[data-kiji-variant-field]");

      if (!axis1Select || !variantSelect || !lengthSelect) throw new Error("Purchase sheet controls were not created");
      if (config.variantAxes) {
        axis1Select.appendChild(new Option(config.variantAxes.axis1Label + "を選択", ""));
        config.variantAxes.axis1Values.forEach(function (value) {
          axis1Select.appendChild(new Option(value, value));
        });
      } else if (axis1Field) {
        axis1Field.hidden = true;
      }

      populateVariantOptions(variantSelect);
      if (config.variants.length === 1 && variantField) variantField.hidden = true;
      populateLengthOptions(lengthSelect);

      axis1Select.addEventListener("change", function () {
        state.sheetSelectionTouched = true;
        state.variantAxis1 = axis1Select.value || null;
        state.variantId = null;
        if (config.usesLength) state.lengthCm = null;
        render();
      });
      variantSelect.addEventListener("change", function () {
        state.sheetSelectionTouched = true;
        state.variantId = variantSelect.value || null;
        if (config.usesLength) state.lengthCm = null;
        render();
      });
      lengthSelect.addEventListener("change", function () {
        state.sheetSelectionTouched = true;
        if (config.usesLength) state.lengthCm = lengthSelect.value || null;
        else state.quantityUnits = lengthSelect.value || "1";
        render();
      });
      document.querySelectorAll(".kiji-mobile-atc__sheet .kiji-mobile-atc__button").forEach(function (button) {
        button.addEventListener("click", function () {
          if (button.dataset.action === "checkout") proceedFromSheet();
          else addSelected();
        });
      });
      document.querySelector(".kiji-mobile-atc__backdrop").addEventListener("click", closeSheet);
      document.querySelector(".kiji-mobile-atc__close").addEventListener("click", closeSheet);
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeSheet();
      });
      return true;
    } catch (error) {
      closeSheet();
      document.querySelectorAll(".kiji-mobile-atc__backdrop, .kiji-mobile-atc__sheet, .kiji-mobile-atc__toast").forEach(function (node) {
        node.remove();
      });
      return false;
    }
  }

  // selleasy-mobile-sheet-20260909-v1
  var sheetAddonHome = null;
  var sheetAddonWidget = null;
  var sheetAddonObserver = null;
  var forwardingSheetPurchase = false;

  function hasSheetAddons() {
    return /^(?:\/products\/hagire200g|\/products\/3mm-doll-button)$/.test(path);
  }

  function mountSheetAddons() {
    if (!hasSheetAddons()) return;
    var content = document.querySelector('.kiji-mobile-atc__content');
    var widget = document.querySelector('lb-upsell-widget:has(lb-addon)');
    if (!content || !widget) return;
    if (sheetAddonObserver) { sheetAddonObserver.disconnect(); sheetAddonObserver = null; }
    if (!sheetAddonHome) {
      sheetAddonHome = document.createComment('Selleasy product-page position');
      widget.parentNode.insertBefore(sheetAddonHome, widget);
      sheetAddonWidget = widget;
    }
    if (widget.parentNode !== content) content.appendChild(widget);
    var label = document.querySelector('.kiji-mobile-atc__total > span');
    if (label) label.textContent = '商品の小計';
  }

  function openSheetAddons() {
    if (!hasSheetAddons()) return;
    mountSheetAddons();
    if (!sheetAddonWidget) {
      sheetAddonObserver = new MutationObserver(mountSheetAddons);
      sheetAddonObserver.observe(document.body, {childList:true, subtree:true});
    }
  }

  function restoreSheetAddons() {
    if (sheetAddonObserver) { sheetAddonObserver.disconnect(); sheetAddonObserver = null; }
    if (sheetAddonWidget && sheetAddonHome && sheetAddonHome.parentNode) {
      sheetAddonHome.parentNode.insertBefore(sheetAddonWidget, sheetAddonHome);
      sheetAddonHome.remove();
    }
    sheetAddonWidget = null;
    sheetAddonHome = null;
  }

  function addSheetThroughNativeForm(variant, units) {
    var form = document.querySelector('form[id^="product-form-main"]:has(button[type="submit"])');
    var id = nativeFormControl(form, 'select[name="id"], input[name="id"]:not(:disabled)');
    var quantity = nativeFormControl(form, 'select[name="quantity"], input[name="quantity"]');
    var button = form && form.querySelector('button[type="submit"]');
    if (!form || !id || !quantity || !button) {
      setToast('商品ページの購入欄から追加してください');
      return Promise.resolve(false);
    }
    state.busy = true;
    forwardingSheetPurchase = true;
    render();
    var previous = {id:id.value, quantity:quantity.value, disabled:button.disabled};
    id.value = String(variant.id);
    quantity.value = String(Math.max(1, Math.round(units)));
    button.disabled = false;
    return new Promise(function(resolve) {
      var settled = false;
      var timer;
      function finish(ok, message) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        form.removeEventListener('variant:add', success);
        form.removeEventListener('cart:error', failure);
        forwardingSheetPurchase = false;
        id.value = previous.id;
        quantity.value = previous.quantity;
        button.disabled = previous.disabled;
        state.busy = false;
        if (ok) { closeSheet(); resetSelectionAfterAdd(); }
        if (message) setToast(message);
        render();
        updateCartCount();
        resolve(ok);
      }
      function success(event) {
        if ((event.detail.items || []).some(function(item) { return String(item.variant_id || item.id) === String(variant.id); })) finish(true);
      }
      function failure(event) { finish(false, event.detail.error || 'カート追加に失敗しました'); }
      form.addEventListener('variant:add', success);
      form.addEventListener('cart:error', failure);
      timer = setTimeout(function() { finish(false, 'カートの内容を確認してください'); }, 30000);
      button.click();
    });
  }

  function hasNativeOnlyPurchaseFields(form) {
    return !!form && Array.from(form.elements || []).some(function (control) {
      return !control.disabled && (/^properties\[/.test(control.name || '') || control.name === 'selling_plan' || control.type === 'file');
    });
  }

  function showNativePurchaseFields(form) {
    closeSheet();
    var fields = Array.from(form.elements || []).filter(function (control) {
      return !control.disabled && control.type !== 'hidden' && (/^properties\[/.test(control.name || '') || control.required);
    });
    var target = fields[0] || form;
    target.scrollIntoView({ block: 'center', behavior: 'auto' });
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) form.reportValidity();
    setToast('品番などを入力し、商品ページの「カートに入れる」から追加してください');
  }

  function nativePropertyForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(function (form) {
      return hasNativeOnlyPurchaseFields(form);
    }) || null;
  }

  function openSheet(options) {
    var nativeForm = nativePropertyForm() || nativeProductForm();
    if (hasNativeOnlyPurchaseFields(nativeForm)) { showNativePurchaseFields(nativeForm); return; }
    options = options || {};
    if (options.syncNative || (state.nativeFormTouched && !state.sheetSelectionTouched)) syncFromNativeProductForm();
    if (!ensureSheet()) return;
    render();
    document.body.classList.add(MARKER + "-open");
    var sheet = document.querySelector(".kiji-mobile-atc__sheet");
    if (sheet) sheet.setAttribute("aria-hidden", "false");
    openSheetAddons();
  }

  function closeSheet() {
    restoreSheetAddons();
    document.body.classList.remove(MARKER + "-open");
    var sheet = document.querySelector(".kiji-mobile-atc__sheet");
    if (sheet) sheet.setAttribute("aria-hidden", "true");
  }

  function updateCartCount() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        state.cartCount = Number(cart.item_count || 0);
      })
      .catch(function () {});
  }

  function nativeProductForm() {
    return document.querySelector('form[id^="product-form-main"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function nativeFormId(form) {
    return form ? form.getAttribute("id") || "" : "";
  }

  function nativeFormControl(form, selector) {
    if (!form) return null;
    var formId = nativeFormId(form);
    var selectors = selector.split(",").map(function (item) { return item.trim(); }).filter(Boolean);
    for (var i = 0; i < selectors.length; i += 1) {
      var node = form.querySelector(selectors[i]);
      if (node) return node;
    }
    if (formId && window.CSS && CSS.escape) {
      for (var j = 0; j < selectors.length; j += 1) {
        var externalNode = document.querySelector(selectors[j] + '[form="' + CSS.escape(formId) + '"]');
        if (externalNode) return externalNode;
      }
    }
    return null;
  }

  function nativeVariantId(form) {
    // Read the selected option in radio-based product forms (e.g. pattern sets).
    var radio = nativeFormControl(form, 'input[name="id"][type="radio"]:checked:not(:disabled)');
    if (radio && radio.value) return String(radio.value);
    var input = nativeFormControl(form, 'input[name="id"]:not([type="radio"]):not(:disabled)');
    if (input && input.value) return String(input.value);
    var select = nativeFormControl(form, 'select[name="id"]');
    if (select && select.value) return String(select.value);
    var anyInput = nativeFormControl(form, 'input[name="id"]:not([type="radio"])');
    if (anyInput && anyInput.value) return String(anyInput.value);
    return currentFormVariantId();
  }

  function nativeQuantityUnits(form) {
    var quantity = nativeFormControl(form, 'select[name="quantity"], input[name="quantity"]');
    var value = quantity && quantity.value ? Number(quantity.value) : 0;
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function isMobileViewport() {
    return !window.matchMedia || window.matchMedia("(max-width: 767px)").matches;
  }

  function isNativeAddSubmit(event) {
    var submitter = event && event.submitter ? event.submitter : document.activeElement;
    if (!submitter) return true;
    if (submitter.closest && submitter.closest(".kiji-mobile-atc, .kiji-mobile-atc__sheet")) return false;

    var text = normalizeText(submitter.textContent || submitter.value || "");
    if (/購入手続き|今すぐ購入|checkout|buy now|shop pay|paypal/i.test(text)) return false;
    if (/カート|追加|add to cart/i.test(text)) return true;
    return submitter.type === "submit";
  }

  function syncFromNativeProductForm() {
    var form = nativeProductForm();
    if (!form || !config) return false;
    var variantId = nativeVariantId(form);
    var variant = config.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });
    if (!variant) return false;

    state.variantId = String(variant.id);
    if (config.variantAxes) state.variantAxis1 = variant.axis1 || state.variantAxis1;

    if (config.usesLength) {
      var units = nativeQuantityUnits(form);
      if (units > 0) state.lengthCm = String(Math.round(units * (config.stepCm || 50)));
    } else {
      var quantityUnits = nativeQuantityUnits(form);
      if (quantityUnits > 0) state.quantityUnits = String(Math.round(quantityUnits));
    }

    return true;
  }

  function bindNativeProductFormSync() {
    var form = nativeProductForm();
    if (!form || form.dataset.kijiMobileAtcNativeSync === "true") return;
    form.dataset.kijiMobileAtcNativeSync = "true";

    var markAndSync = function () {
      state.sheetSelectionTouched = false;
      state.nativeFormTouched = true;
      syncFromNativeProductForm();
      render();
    };

    form.addEventListener("change", markAndSync, true);
    form.addEventListener("variant:change", markAndSync);
    form.addEventListener("submit", function (event) {
      if (hasNativeOnlyPurchaseFields(form)) return;
      if (forwardingSheetPurchase || !isProductPage || !isMobileViewport() || !config || !isNativeAddSubmit(event)) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (typeof form.checkValidity === "function" && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      state.nativeFormTouched = true;
      syncFromNativeProductForm();
      openSheet({ syncNative: true });
    }, true);

    var formId = nativeFormId(form);
    if (formId && window.CSS && CSS.escape) {
      document.querySelectorAll('[form="' + CSS.escape(formId) + '"]').forEach(function (control) {
        control.addEventListener("change", markAndSync, true);
      });
    }
  }

  function syncAndRenderNativeProductForm() {
    // Preserve a customer selection against delayed initial native-form sync.
    if (state.sheetSelectionTouched) return;
    if (syncFromNativeProductForm()) render();
  }

  function resetSelectionAfterAdd() {
    if (config.variantAxes) state.variantAxis1 = null;
    if (config.variants.length > 1) {
      state.variantId = null;
    } else if (config.variants.length === 1) {
      state.variantId = String(config.variants[0].id);
    }
    if (config.usesLength) state.lengthCm = null;
    else state.quantityUnits = "1";
    state.nativeFormTouched = false;
    state.sheetSelectionTouched = false;
  }

  function selectedPurchaseLabel(units, lengthCm) {
    if (config.usesLength) return lengthCm ? lengthLabel(Number(lengthCm)) : "";
    var quantity = Math.max(1, Math.round(Number(units || 1)));
    return quantity > 1 ? "数量" + quantity : "";
  }

  function addSelected(options) {
    var nativeForm = nativePropertyForm() || nativeProductForm();
    if (hasNativeOnlyPurchaseFields(nativeForm)) { showNativePurchaseFields(nativeForm); return Promise.resolve(false); }
    options = options || {};
    if (options.syncNative) syncFromNativeProductForm();
    var variant = selectedVariant();
    var units = lengthUnits();
    var addedLengthCm = state.lengthCm;
    var addedPurchaseLabel = selectedPurchaseLabel(units, addedLengthCm);
    if (!variant || !units || (config.usesLength && !state.lengthCm)) {
      openSheet();
      return Promise.resolve(false);
    }
    if (!variant.available) {
      setToast("この商品は在庫がありません");
      openSheet();
      return Promise.resolve(false);
    }
    if (state.busy) return Promise.resolve(false);
    if (hasSheetAddons() && document.querySelector("lb-upsell-widget lb-addon")) return addSheetThroughNativeForm(variant, units);

    state.busy = true;
    render();
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variant.id,
        quantity: Math.max(1, Math.round(units))
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw new Error(json && json.description ? json.description : "カート追加に失敗しました");
          return json;
        });
      })
      .then(function (item) {
        document.dispatchEvent(new CustomEvent("variant:add", { detail: { items: [item] } }));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        state.cartCount += Math.max(1, Math.round(units));
        closeSheet();
        setToast(variant.title + (addedPurchaseLabel ? " / " + addedPurchaseLabel : "") + " をカートに追加しました");
        resetSelectionAfterAdd();
        return true;
      })
      .catch(function (error) {
        setToast(error.message || "カート追加に失敗しました");
        return false;
      })
      .finally(function () {
        state.busy = false;
        render();
        return updateCartCount();
      });
  }

  function goToCart() {
    window.location.href = "/cart";
  }

  function hasReadySelection() {
    return !!(selectedVariant() && (!config.usesLength || state.lengthCm));
  }

  function proceedFromPageCta() {
    updateCartCount().then(function () {
      if (state.cartCount > 0) {
        goToCart();
        return;
      }
      openSheet();
    });
  }

  function proceedFromSheet() {
    addSelected().then(function (added) {
      if (added) goToCart();
    });
  }

  function render() {
    var variant = selectedVariant();
    var previewVariant = variant || previewVariantForCurrentAxis();
    var image = previewVariant && previewVariant.image ? previewVariant.image : config.image;
    var sheetImage = document.querySelector(".kiji-mobile-atc__product img");
    var axis1Select = document.querySelector("#kijiMobileAtcAxis1");
    var variantSelect = document.querySelector("#kijiMobileAtcVariant");
    var lengthSelect = document.querySelector("#kijiMobileAtcLength");
    var purchaseFieldLabel = document.querySelector("[data-kiji-length-field] label");
    var totalNode = document.querySelector(".kiji-mobile-atc__total strong");
    var stockNode = document.querySelector(".kiji-mobile-atc__stock-note");
    var buttons = document.querySelectorAll(".kiji-mobile-atc__button");

    if (sheetImage && sheetImage.getAttribute("src") !== sheetPreviewImageUrl(image)) sheetImage.src = sheetPreviewImageUrl(image);
    if (path === "/products/4500") {
      var unitPriceNode = document.querySelector(".kiji-mobile-atc__product-price");
      if (unitPriceNode && variant) unitPriceNode.innerHTML = yen(variant.price).replace("¥", "") + "円<small>" + escapeHtml(config.priceSuffix) + "</small>";
      var sheetTitleNode = document.querySelector("#kijiMobileAtcTitle");
      if (sheetTitleNode) sheetTitleNode.textContent = "色・長さを選ぶ";
    }
    if (axis1Select) axis1Select.value = state.variantAxis1 || "";
    if (variantSelect) {
      populateVariantOptions(variantSelect);
      variantSelect.value = state.variantId || "";
    }
    if (lengthSelect) {
      populateLengthOptions(lengthSelect);
      lengthSelect.value = config.usesLength ? (state.lengthCm || "") : String(state.quantityUnits || "1");
    }
    if (path === "/products/4500" && lengthSelect) {
      var shortcuts = document.querySelector(".m4500-lengths");
      if (!shortcuts) {
        shortcuts = document.createElement("div");
        shortcuts.className = "m4500-lengths";
        shortcuts.setAttribute("role", "group");
        shortcuts.setAttribute("aria-label", "長さをすぐ選ぶ");
        [50, 100, 150, 200].forEach(function(cm) {
          var shortcut = document.createElement("button");
          shortcut.type = "button"; shortcut.dataset.cm = String(cm);
          shortcut.textContent = cm < 100 ? "50cm" : (cm / 100) + "m";
          shortcut.addEventListener("click", function() {
            if (shortcut.disabled) return;
            lengthSelect.value = shortcut.dataset.cm;
            lengthSelect.dispatchEvent(new Event("change", {bubbles:true}));
          });
          shortcuts.appendChild(shortcut);
        });
        lengthSelect.parentElement.after(shortcuts);
      }
      shortcuts.querySelectorAll("button").forEach(function(shortcut) {
        shortcut.disabled = lengthSelect.disabled || !Array.from(lengthSelect.options).some(function(option) { return option.value === shortcut.dataset.cm && !option.disabled; });
        shortcut.setAttribute("aria-pressed", String(lengthSelect.value === shortcut.dataset.cm));
      });
    }
    if (purchaseFieldLabel) purchaseFieldLabel.textContent = config.purchaseFieldLabel || (config.usesLength ? "長さ" : "数量");
    var total = totalPrice();
    var totalText = total == null ? yen(config.minPrice) + "〜" : yen(total);
    if (totalNode) totalNode.textContent = totalText;
    if (stockNode) {
      var message = stockLengthMessage(variant);
      stockNode.textContent = message;
      stockNode.hidden = !message;
    }
    buttons.forEach(function (button) {
      button.disabled = state.busy;
      button.textContent = button.dataset.action === "checkout" ? "購入手続きへ" : "カートに追加";
      if (path === "/products/4500" && button.closest(".kiji-mobile-atc__sheet") && button.dataset.action === "checkout") button.textContent = "追加してカートへ";
      if (path === "/products/4500" && button.closest(".kiji-mobile-atc")) {
        button.textContent = button.dataset.action === "checkout" ? (state.cartCount > 0 ? "カートを見る" : "購入手続きへ") : "色・長さを選ぶ";
      }
    });
  }

  function previewBarOffset() {
    var selectors = [
      "#PBarNextFrameWrapper",
      "#preview-bar-iframe",
      "iframe[src*='preview_bar']",
      "iframe[src*='theme_preview']",
      ".shopify-preview-bar"
    ];
    for (var i = 0; i < selectors.length; i += 1) {
      var node = document.querySelector(selectors[i]);
      if (!node) continue;
      var rect = node.getBoundingClientRect();
      var style = getComputedStyle(node);
      if (style.display !== "none" && style.visibility !== "hidden" && rect.height > 32 && rect.bottom > window.innerHeight - 6) {
        return Math.ceil(rect.height);
      }
    }
    if (window.Shopify && window.Shopify.designMode) return 72;
    return 0;
  }

  function updateBottomOffset() {
    var offset = previewBarOffset();
    document.body.style.setProperty("--kiji-mobile-atc-bottom-offset", offset + "px");
  }

  var searchTopOffsetQueued = false;

  function updateSearchTopOffset() {
    if (!isMobileViewport()) return;
    var headers = Array.from(document.querySelectorAll(".shopify-section-group-header-group"));
    var headerBottom = headers.reduce(function (maxBottom, node) {
      var style = getComputedStyle(node);
      if (style.display === "none" || style.visibility === "hidden") return maxBottom;
      var rect = node.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return maxBottom;
      return Math.max(maxBottom, Math.round(rect.bottom));
    }, 0);
    var searchBar = document.querySelector(".kiji-mobile-search");
    var searchHeight = 0;
    if (searchBar) {
      var searchStyle = getComputedStyle(searchBar);
      var searchRect = searchBar.getBoundingClientRect();
      if (searchStyle.display !== "none" && searchStyle.visibility !== "hidden") {
        searchHeight = Math.max(0, Math.round(searchRect.height));
      }
    }
    var top = headerBottom + "px";
    var overlayTop = (headerBottom + searchHeight) + "px";
    if (document.body.style.getPropertyValue("--kiji-mobile-search-top") !== top) {
      document.body.style.setProperty("--kiji-mobile-search-top", top);
    }
    if (document.body.style.getPropertyValue("--kiji-mobile-overlay-top") !== overlayTop) {
      document.body.style.setProperty("--kiji-mobile-overlay-top", overlayTop);
    }
  }

  function scheduleSearchTopOffset() {
    if (searchTopOffsetQueued) return;
    searchTopOffsetQueued = true;
    window.requestAnimationFrame(function () {
      searchTopOffsetQueued = false;
      updateSearchTopOffset();
    });
  }

  function isDrawerOpenForSearch() {
    return [
      "#unified-drawer",
      "#sidebar-menu",
      "#support-drawer",
      "#cart-drawer"
    ].some(function (selector) {
      var drawer = document.querySelector(selector);
      return !!(drawer && drawer.hasAttribute("open"));
    });
  }

  function isThemeDialogOpenForAtc() {
    var selectors = [
      "x-popover",
      "shop-the-look-popover",
      "x-modal",
      "x-drawer",
      "cart-drawer",
      "header-sidebar",
      "facets-drawer"
    ];
    return Array.from(document.querySelectorAll(selectors.join(","))).some(function (dialog) {
      if (!dialog || !dialog.hasAttribute("open")) return false;
      if (dialog.closest(".kiji-mobile-atc__sheet")) return false;
      return true;
    });
  }

  function syncDrawerSearchVisibility() {
    document.body.classList.toggle(MARKER + "-drawer-open", isDrawerOpenForSearch());
    document.body.classList.toggle(MARKER + "-theme-dialog-open", isThemeDialogOpenForAtc());
    updateSearchTopOffset();
  }

  function startDrawerSearchObserver() {
    if (window.__kijiMobileVariantAtcDrawerSearchObserver20260727) return;
    window.__kijiMobileVariantAtcDrawerSearchObserver20260727 = true;
    var queued = false;
    var schedule = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        syncDrawerSearchVisibility();
      });
    };
    // Only dialog open state affects this UI; unrelated class changes must not force header layout.
    var dialogSelector = "#unified-drawer, #sidebar-menu, #support-drawer, #cart-drawer, x-popover, shop-the-look-popover, x-modal, x-drawer, cart-drawer, header-sidebar, facets-drawer";
    function includesDialog(node) {
      return node.nodeType === 1 && (node.matches(dialogSelector) || node.querySelector(dialogSelector));
    }
    new MutationObserver(function (mutations) {
      if (!isMobileViewport()) return;
      var relevant = mutations.some(function (mutation) {
        if (mutation.type === "attributes") return mutation.target.matches(dialogSelector);
        return Array.from(mutation.addedNodes).some(includesDialog) || Array.from(mutation.removedNodes).some(includesDialog);
      });
      if (relevant) schedule();
    }).observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["open"]
    });
    schedule();
  }

  function mountSearchBar() {
    var searchBar = document.querySelector(".kiji-mobile-search");
    if (!searchBar) {
      searchBar = document.createElement("div");
      searchBar.className = "kiji-mobile-search";
      searchBar.setAttribute("aria-label", "商品検索");
      searchBar.innerHTML = [
        '  <form class="kiji-mobile-search__form" action="/search" method="GET" role="search">',
        '    <label class="kiji-mobile-search__label" for="kijiMobileSearchInput">商品検索</label>',
        '    <span class="kiji-mobile-search__icon" aria-hidden="true"></span>',
        '    <input class="kiji-mobile-search__input" id="kijiMobileSearchInput" type="search" name="q" placeholder="すべての生地から探す" autocomplete="off">',
        "  </form>",
        '  <button class="kiji-mobile-search__cancel" type="button" aria-label="検索をキャンセル">キャンセル</button>'
      ].join("");

      var headerGroups = document.querySelectorAll(".shopify-section-group-header-group");
      var lastHeaderGroup = headerGroups.length ? headerGroups[headerGroups.length - 1] : null;
      if (lastHeaderGroup && lastHeaderGroup.parentNode) {
        lastHeaderGroup.insertAdjacentElement("afterend", searchBar);
      } else {
        document.body.insertBefore(searchBar, document.body.firstChild);
      }
    }

    if (searchBar.dataset.kijiMobileSearchBound !== "true") {
      searchBar.dataset.kijiMobileSearchBound = "true";
      var input = searchBar.querySelector(".kiji-mobile-search__input");
      var form = searchBar.querySelector(".kiji-mobile-search__form");
      var cancel = searchBar.querySelector(".kiji-mobile-search__cancel");
      if (input && form && cancel) {
        input.addEventListener("focus", function () {
          searchBar.classList.add("kiji-mobile-search--focused");
        });
        input.addEventListener("blur", function () {
          window.setTimeout(function () {
            if (!searchBar.contains(document.activeElement)) {
              searchBar.classList.remove("kiji-mobile-search--focused");
            }
          }, 0);
        });
        form.addEventListener("submit", function (event) {
          if (!input.value.trim()) {
            event.preventDefault();
            input.focus();
          }
        });
        cancel.addEventListener("click", function (event) {
          event.preventDefault();
          input.value = "";
          searchBar.classList.remove("kiji-mobile-search--focused");
          input.blur();
          cancel.blur();
        });
      }
      window.setTimeout(updateSearchTopOffset, 500);
      window.setTimeout(updateSearchTopOffset, 1600);
      window.addEventListener("resize", updateSearchTopOffset, { passive: true });
      window.addEventListener("scroll", scheduleSearchTopOffset, { passive: true });
    }

    document.body.classList.add(MARKER + "-search-active");
    startDrawerSearchObserver();
    syncDrawerSearchVisibility();
    updateSearchTopOffset();
  }

  // Show the mobile purchase bar only after the main add-to-cart button passes above the viewport.
  function bindPurchaseBarScrollVisibility() {
    var bar = document.querySelector('.kiji-mobile-atc');
    var queued = false;
    function update() {
      queued = false;
      var button = document.querySelector('.product-info buy-buttons button[type="submit"]');
      var passed = !!button && button.getClientRects().length > 0 && button.getBoundingClientRect().bottom <= 0;
      if (passed) bar.style.removeProperty('display');
      else bar.style.setProperty('display', 'none', 'important');
    }
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('variant:change', schedule);
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(schedule);
      observer.observe(document.querySelector('main') || document.body);
    }
    update();
  }

  function mount() {
    mountSearchBar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
/* mobile-variant-atc-prototype-20260725:end */

/* blog-category-compact-unified-20260806:js:start */
(function () {
  "use strict";
  var runtimeMarker = "__maruishiBlogCategoryCompactUnified20260806";
  if (window[runtimeMarker]) return;
  window[runtimeMarker] = true;

  var categories = [
    ["お知らせ", "お知らせ"],
    ["生地の選び方", "生地選び"],
    ["作り方・型紙", "作り方"],
    ["作品例・布合わせ", "作品例"],
    ["入園入学", "入園入学"],
    ["子ども服・ベビー", "子ども"],
    ["大人服・エプロン", "大人服"],
    ["バッグ・小物", "バッグ"],
    ["犬服・ドール服", "犬・ドール"],
    ["ミシン・道具", "ミシン"]
  ];

  function decodedPath() {
    try {
      return decodeURIComponent(window.location.pathname || "");
    } catch (error) {
      return window.location.pathname || "";
    }
  }

  function shouldRun() {
    var path = decodedPath();
    return path === "/blogs/journal" || path.indexOf("/blogs/journal/") === 0;
  }

  function categoryHandle(fullLabel) {
    return fullLabel.replace(/・/g, "-");
  }

  function isActive(fullLabel) {
    return decodedPath() === "/blogs/journal/tagged/" + categoryHandle(fullLabel);
  }

  function tagHref(fullLabel) {
    return "/blogs/journal/tagged/" + encodeURIComponent(categoryHandle(fullLabel));
  }

  function buildAnchor(fullLabel, shortLabel) {
    var anchor = document.createElement("a");
    anchor.href = isActive(fullLabel) ? "/blogs/journal" : tagHref(fullLabel);
    anchor.className = "blog-category-list__tag " + (isActive(fullLabel) ? "is-active" : "is-faded");
    anchor.setAttribute("aria-current", isActive(fullLabel) ? "true" : "false");
    anchor.setAttribute("aria-label", "#" + fullLabel);
    anchor.title = fullLabel;
    anchor.textContent = "#" + shortLabel;
    return anchor;
  }

  function fillList(list, itemTagName) {
    list.textContent = "";
    list.classList.add("blog-category-list__tags", "blog-tags--compact");
    list.setAttribute("role", "list");
    list.setAttribute("aria-label", "ブログカテゴリ");

    categories.forEach(function (category) {
      var fullLabel = category[0];
      var shortLabel = category[1];
      if (itemTagName === "li") {
        var li = document.createElement("li");
        li.appendChild(buildAnchor(fullLabel, shortLabel));
        list.appendChild(li);
        return;
      }
      var anchor = buildAnchor(fullLabel, shortLabel);
      anchor.setAttribute("role", "listitem");
      list.appendChild(anchor);
    });
  }

  function ensureMainBlogCategories() {
    var section = document.querySelector(".shopify-section--main-blog");
    if (!section) return false;

    var stack = section.querySelector(".section-stack > .v-stack") || section.querySelector(".section-stack");
    if (!stack) return false;
    stack.classList.add("blog-index-category-compact");
    stack.setAttribute("data-blog-category-style", "blog-category-compact-unified-20260806");

    var h1 = stack.querySelector("h1.h2") || section.querySelector("h1.h2");
    if (h1 && h1.textContent.trim() === "お読みもの") h1.textContent = "ブログカテゴリ";

    var list = stack.querySelector(".blog-tags:not(.blog-post-card__tags)");
    if (!list) {
      list = document.createElement("ul");
      list.className = "blog-tags unstyled-list";
      var header = h1 ? h1.closest(".section-header") : null;
      (header || stack).insertAdjacentElement("afterend", list);
    }

    fillList(list, "li");
    return true;
  }

  function ensureArticleCategorySections() {
    var changed = false;
    document.querySelectorAll(".blog-category-list").forEach(function (section) {
      var hasTags = section.querySelector(".blog-category-list__tag");
      var empty = section.querySelector(".blog-category-list__empty");
      if (hasTags && !empty) return;

      if (empty) {
        empty.dataset.blogCategoryReplaced = "true";
        empty.hidden = true;
      }

      var list = section.querySelector(".blog-category-list__tags");
      if (!list) {
        list = document.createElement("div");
        list.className = "blog-category-list__tags";
        var header = section.querySelector(".section-header");
        (header || section.querySelector(".blog-category-list__inner") || section).insertAdjacentElement("afterend", list);
      }
      fillList(list, "a");
      changed = true;
    });
    return changed;
  }

  function run() {
    if (!shouldRun()) return;
    ensureMainBlogCategories();
    ensureArticleCategorySections();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
  window.addEventListener("pageshow", run);
  setTimeout(run, 350);
  setTimeout(run, 1200);
})();
/* blog-category-compact-unified-20260806:js:end */


/* home-new-color-variant-cards-20260807: replace stale cached home new-arrivals HTML with the current variant-card section. */
(() => {
  const marker = 'home-new-color-variant-cards-20260807';
  const sectionSelector = '[id$="__new_arrivals_top"]';
  const sectionInnerSelector = '.product-slider';
  function refreshHomeNewColorArrivals() {
    if (window.location.pathname !== '/') return;
    const current = document.querySelector(sectionSelector);
    if (!current || document.documentElement.innerHTML.includes(marker)) return;
    const url = new URL(window.location.href);
    url.searchParams.set('_home_new_color_arrivals', '20260807');
    fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => response.ok ? response.text() : '')
      .then((html) => {
        if (!html || !html.includes(marker)) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(sectionSelector);
        const stale = document.querySelector(sectionSelector);
        if (!fresh || !stale) return;
        stale.replaceWith(document.importNode(fresh, true));
        const inserted = document.querySelector(sectionSelector);
        if (inserted && typeof window.initOrUpdateSlider === 'function') {
          inserted.querySelectorAll(sectionInnerSelector).forEach((slider) => window.initOrUpdateSlider(slider));
        } else {
          window.dispatchEvent(new Event('resize'));
        }
      })
      .catch(() => {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshHomeNewColorArrivals, { once: true });
  } else {
    refreshHomeNewColorArrivals();
  }
})();


/* home-new-color-variant-cards-20260807-v2: replace stale cached home new-arrivals HTML with the current variant-card section. */
(() => {
  const marker = 'home-new-color-variant-cards-20260807';
  const fallbackMarker = 'home-new-color-variant-cards-20260807-v2';
  const sectionSelector = '[id$="__new_arrivals_top"]';
  const sectionInnerSelector = '.product-slider';
  function refreshHomeNewColorArrivals() {
    if (window.location.pathname !== '/') return;
    const current = document.querySelector(sectionSelector);
    if (!current || document.documentElement.innerHTML.includes(marker)) return;
    const sectionId = (current.id || '').replace(/^shopify-section-/, '');
    if (!sectionId) return;
    const url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('_home_new_color_arrivals', fallbackMarker);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => response.ok ? response.text() : '')
      .then((html) => {
        if (!html || !html.includes(marker)) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(sectionSelector);
        const stale = document.querySelector(sectionSelector);
        if (!fresh || !stale) return;
        stale.replaceWith(document.importNode(fresh, true));
        const inserted = document.querySelector(sectionSelector);
        if (inserted && typeof window.initOrUpdateSlider === 'function') {
          inserted.querySelectorAll(sectionInnerSelector).forEach((slider) => window.initOrUpdateSlider(slider));
        } else {
          window.dispatchEvent(new Event('resize'));
        }
      })
      .catch(() => {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshHomeNewColorArrivals, { once: true });
  } else {
    refreshHomeNewColorArrivals();
  }
})();

// Removed obsolete variant-gallery-filter-fallback-20260818-v4: one gallery updater owns all-visible ordering.

/* home-work-example-app-shelves-20260806-v4:start */
(function () {
  "use strict";

  var marker = "home-work-example-app-shelves-20260806-v4";
  var summerSectionId = "summer_recommended_fabrics_flick30_black_v2";
  var newsletterSectionId = "home_newsletter_signup_20260715";
  var sections = [{"rawId":"new_work_examples_home_flick_20260810_v1","title":"新着作品","link":"/blogs/work-examples"},{"rawId":"adult_work_examples_home_flick_20260806_v4","title":"大人服の作品例","link":"/blogs/work-examples/otona"},{"rawId":"kids_work_examples_home_flick_20260806_v4","title":"子供服の作品例","link":"/blogs/work-examples/kodomo"}];
  var attempts = 0;
  window.__homeWorkExampleShelvesRefresh = marker;

  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function byRawId(rawId) {
    return document.querySelector('[id$="__' + rawId + '"]');
  }

  function validSection(node, spec) {
    if (!node) return false;
    var html = node.innerHTML || "";
    var text = node.textContent || "";
    return text.indexOf(spec.title) !== -1 && html.indexOf(spec.link) !== -1 && html.indexOf("Liquid error") === -1;
  }

  function templatePrefix() {
    var candidates = [byRawId(summerSectionId), byRawId(newsletterSectionId), document.querySelector('[id^="shopify-section-template--"]')];
    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node || !node.id) continue;
      var id = node.id.replace(/^shopify-section-/, "");
      var index = id.lastIndexOf("__");
      if (index >= 0) return id.slice(0, index + 2);
    }
    return "";
  }

  function parseSection(html, spec) {
    if (!html || html.indexOf(spec.title) === -1 || html.indexOf(spec.link) === -1 || html.indexOf("Liquid error") !== -1) return null;
    var template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  }

  function placeInOrder() {
    var summer = byRawId(summerSectionId);
    var newsletter = byRawId(newsletterSectionId);
    var latest = byRawId(sections[0].rawId);
    var adult = byRawId(sections[1].rawId);
    var kids = byRawId(sections[2].rawId);

    if (summer && latest) summer.insertAdjacentElement("afterend", latest);
    if (latest && adult) latest.insertAdjacentElement("afterend", adult);
    if (adult && kids) adult.insertAdjacentElement("afterend", kids);
    if (!summer && newsletter) {
      if (latest && latest.nextElementSibling !== adult) newsletter.parentNode.insertBefore(latest, newsletter);
      if (adult && adult.nextElementSibling !== kids) newsletter.parentNode.insertBefore(adult, newsletter);
      if (kids) newsletter.parentNode.insertBefore(kids, newsletter);
    }
  }

  function insertSection(html, spec) {
    var section = parseSection(html, spec);
    if (!section) return;

    var existing = byRawId(spec.rawId);
    if (existing) existing.replaceWith(section);
    else {
      var newsletter = byRawId(newsletterSectionId);
      if (!newsletter || !newsletter.parentNode) return;
      newsletter.parentNode.insertBefore(section, newsletter);
    }
  }

  function refreshWorkShelves() {
    if (!isHome() || !window.fetch) return;

    if (!byRawId(summerSectionId) && attempts < 8) {
      attempts += 1;
      window.setTimeout(refreshWorkShelves, 250);
      return;
    }

    var prefix = templatePrefix();
    if (!prefix) return;

    var pending = sections.filter(function (spec) {
      return !validSection(byRawId(spec.rawId), spec);
    });

    if (!pending.length) {
      placeInOrder();
      return;
    }

    Promise.all(pending.map(function (spec) {
      var url = new URL(window.location.href);
      url.search = "";
      url.searchParams.set("section_id", prefix + spec.rawId);
      url.searchParams.set("_work_shelf_refresh", "20260805");
      return fetch(url.toString(), {
        credentials: "same-origin",
        headers: {
          Accept: "text/html",
          "cache-control": "no-cache",
          pragma: "no-cache"
        }
      })
        .then(function (response) {
          return response.ok ? response.text() : "";
        })
        .then(function (html) {
          insertSection(html, spec);
        });
    }))
      .then(placeInOrder)
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshWorkShelves);
  } else {
    refreshWorkShelves();
  }
  window.addEventListener("pageshow", refreshWorkShelves);
  window.setTimeout(refreshWorkShelves, 1500);
})();
/* home-work-example-app-shelves-20260806-v4:end */


/* home-new-arrivals-mq22-refresh-20260810-v1: refresh cached home new-arrivals when the latest registered product is missing. */
(() => {
  const targetHandle = 'mq22-3012';
  const marker = 'home-new-arrivals-mq22-refresh-20260810-v1';
  const sectionSelector = '[id$="__new_arrivals_top"]';
  function refreshHomeNewArrivals() {
    if (window.location.pathname !== '/') return;
    const section = document.querySelector(sectionSelector);
    if (!section || section.innerHTML.includes('/products/' + targetHandle)) return;
    const sectionId = (section.id || '').replace(/^shopify-section-/, '');
    if (!sectionId) return;
    const url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('_home_new_arrivals_refresh', marker);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => response.ok ? response.text() : '')
      .then((html) => {
        if (!html || !html.includes('/products/' + targetHandle)) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(sectionSelector);
        const stale = document.querySelector(sectionSelector);
        if (!fresh || !stale) return;
        stale.replaceWith(document.importNode(fresh, true));
        const inserted = document.querySelector(sectionSelector);
        if (inserted && typeof window.initOrUpdateSlider === 'function') {
          inserted.querySelectorAll('.product-slider').forEach((slider) => window.initOrUpdateSlider(slider));
        } else {
          window.dispatchEvent(new Event('resize'));
        }
      })
      .catch(() => {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshHomeNewArrivals, { once: true });
  } else {
    refreshHomeNewArrivals();
  }
})();

/* home-new-arrivals-latest-refresh-20260825-v1: refresh cached home new-arrivals when latest products are missing or old manual cards lead. */
(() => {
  const marker = 'home-new-arrivals-latest-refresh-20260825-v1';
  const expectedFirst = 'icm13000';
  const expectedHandles = ["icm13000","5-1350","kag0012"];
  const sectionSelector = '[id$="__new_arrivals_top"]';
  function productLinks(root) {
    return Array.from(root.querySelectorAll('a[href^="/products/"]')).map((anchor) => {
      const match = anchor.getAttribute('href').match(/^\/products\/([^?#/]+)/);
      return match ? match[1] : '';
    }).filter(Boolean);
  }
  function needsRefresh(section) {
    const handles = productLinks(section);
    if (handles[0] !== expectedFirst) return true;
    return expectedHandles.some((handle) => !handles.includes(handle));
  }
  function refreshHomeNewArrivalsLatest() {
    if (window.location.pathname !== '/') return;
    const section = document.querySelector(sectionSelector);
    if (!section || !needsRefresh(section)) return;
    const sectionId = (section.id || '').replace(/^shopify-section-/, '');
    if (!sectionId) return;
    const url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('_home_new_arrivals_latest', marker);
    url.searchParams.set('_', String(Date.now()));
    fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => response.ok ? response.text() : '')
      .then((html) => {
        if (!html || expectedHandles.some((handle) => !html.includes('/products/' + handle))) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(sectionSelector);
        const stale = document.querySelector(sectionSelector);
        if (!fresh || !stale || needsRefresh(fresh)) return;
        stale.replaceWith(document.importNode(fresh, true));
        const inserted = document.querySelector(sectionSelector);
        if (inserted && typeof window.initOrUpdateSlider === 'function') {
          inserted.querySelectorAll('.product-slider').forEach((slider) => window.initOrUpdateSlider(slider));
        } else {
          window.dispatchEvent(new Event('resize'));
        }
      })
      .catch(() => {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshHomeNewArrivalsLatest, { once: true });
  } else {
    refreshHomeNewArrivalsLatest();
  }
})();

// fabric-type-menu-links-fallback-20260826-v1
(function () {
  var map = {
    'ダンガリー': '/collections/fabric-type-dungaree',
    'シーチング': '/collections/fabric-type-sheeting',
    'デニム': '/collections/fabric-type-denim',
    '帆布/キャンバス': '/collections/fabric-type-canvas',
    '帆布（キャンバス）': '/collections/fabric-type-canvas',
    'ローン': '/collections/fabric-type-lawn',
    'コーデュロイ': '/collections/fabric-type-corduroy',
    '綿レース・刺しゅう': '/collections/fabric-type-cotton-lace-embroidery',
    'チノ': '/collections/fabric-type-chino',
    'ツイル': '/collections/fabric-type-chino',
    'チノ・ツイル': '/collections/fabric-type-chino',
    'タイプライター': '/collections/fabric-type-typewriter',
    'ギャバジン': '/collections/fabric-type-gabardine',
    'タフタ': '/collections/fabric-type-taffeta',
    'グログラン': '/collections/fabric-type-grosgrain',
    'タオル': '/collections/fabric-type-pile-towel',
    'パイル・タオル': '/collections/fabric-type-pile-towel',
    'キルト': '/collections/fabric-type-quilting',
    'キルティング': '/collections/fabric-type-quilting',
    'オックス': '/collections/fabric-type-oxford',
    'サテン': '/collections/fabric-type-satin',
    'サッカー': '/collections/fabric-type-ripple-seersucker',
    'リップル・サッカー': '/collections/fabric-type-ripple-seersucker',
    'ネル': '/collections/fabric-type-flannel'
  };

  function targetForAnchor(anchor) {
    var raw = anchor.getAttribute('href') || '';
    if (!raw || raw.indexOf('filter.p.m.filter.knitting') === -1) return '';
    var url;
    try {
      url = new URL(raw, window.location.origin);
    } catch (error) {
      return '';
    }
    if (url.pathname !== '/collections/material') return '';
    var values = url.searchParams.getAll('filter.p.m.filter.knitting');
    for (var index = 0; index < values.length; index += 1) {
      if (map[values[index]]) return map[values[index]];
    }
    return '';
  }

  function refreshFabricTypeMenuLinks(root) {
    var scope = root || document;
    var anchors = scope.querySelectorAll('a.link-faded[href*="filter.p.m.filter.knitting"], a.ud-chip[href*="filter.p.m.filter.knitting"]');
    anchors.forEach(function (anchor) {
      var target = targetForAnchor(anchor);
      if (target) anchor.setAttribute('href', target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refreshFabricTypeMenuLinks(document); }, { once: true });
  } else {
    refreshFabricTypeMenuLinks(document);
  }
  window.setTimeout(function () { refreshFabricTypeMenuLinks(document); }, 250);
  window.setTimeout(function () { refreshFabricTypeMenuLinks(document); }, 1200);
})();

// fabric-type-menu-links-fallback-20260826-v2
(function () {
  var map = {
    'ダンガリー': '/collections/fabric-type-dungaree',
    'シーチング': '/collections/fabric-type-sheeting',
    'デニム': '/collections/fabric-type-denim',
    '帆布/キャンバス': '/collections/fabric-type-canvas',
    '帆布（キャンバス）': '/collections/fabric-type-canvas',
    'ローン': '/collections/fabric-type-lawn',
    'コーデュロイ': '/collections/fabric-type-corduroy',
    '綿レース・刺しゅう': '/collections/fabric-type-cotton-lace-embroidery',
    'チノ': '/collections/fabric-type-chino',
    'タイプライター': '/collections/fabric-type-typewriter',
    'ギャバジン': '/collections/fabric-type-gabardine',
    'タフタ': '/collections/fabric-type-taffeta',
    'グログラン': '/collections/fabric-type-grosgrain',
    'タオル': '/collections/fabric-type-pile-towel',
    'パイル・タオル': '/collections/fabric-type-pile-towel',
    'キルト': '/collections/fabric-type-quilting',
    'キルティング': '/collections/fabric-type-quilting',
    'オックス': '/collections/fabric-type-oxford',
    'サテン': '/collections/fabric-type-satin',
    'サッカー': '/collections/fabric-type-ripple-seersucker',
    'リップル・サッカー': '/collections/fabric-type-ripple-seersucker',
    'ネル': '/collections/fabric-type-flannel'
  };

  function targetForAnchor(anchor) {
    var raw = anchor.getAttribute('href') || '';
    if (!raw || raw.indexOf('filter.p.m.filter.knitting') === -1) return '';
    var url;
    try {
      url = new URL(raw, window.location.origin);
    } catch (error) {
      return '';
    }
    if (url.pathname !== '/collections/material') return '';
    var values = url.searchParams.getAll('filter.p.m.filter.knitting');
    for (var index = 0; index < values.length; index += 1) {
      if (map[values[index]]) return map[values[index]];
    }
    return '';
  }

  function refreshFabricTypeMenuLinks(root) {
    var scope = root || document;
    var anchors = scope.querySelectorAll('a.link-faded[href*="filter.p.m.filter.knitting"], a.ud-chip[href*="filter.p.m.filter.knitting"]');
    anchors.forEach(function (anchor) {
      var target = targetForAnchor(anchor);
      if (target) anchor.setAttribute('href', target);
    });
  }

  function redirectSingleFabricTypeFilter() {
    if (window.location.pathname !== '/collections/material') return;
    var params = new URLSearchParams(window.location.search);
    var values = params.getAll('filter.p.m.filter.knitting');
    if (values.length !== 1 || !map[values[0]]) return;

    var passthrough = new URLSearchParams();
    var hasOtherFilter = false;
    params.forEach(function (value, key) {
      if (key === 'filter.p.m.filter.knitting') return;
      if (/^utm_/.test(key) || key === 'gclid' || key === 'fbclid') {
        passthrough.append(key, value);
        return;
      }
      hasOtherFilter = true;
    });
    if (hasOtherFilter) return;

    var query = passthrough.toString();
    window.location.replace(map[values[0]] + (query ? '?' + query : '') + window.location.hash);
  }

  redirectSingleFabricTypeFilter();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refreshFabricTypeMenuLinks(document); }, { once: true });
  } else {
    refreshFabricTypeMenuLinks(document);
  }
  window.setTimeout(function () { refreshFabricTypeMenuLinks(document); }, 250);
  window.setTimeout(function () { refreshFabricTypeMenuLinks(document); }, 1200);
})();

// fabric-type-flannel-cache-redirect-20260826-v1
(function () {
  var flannelPath = '/collections/fabric-type-flannel';
  var flannelTarget = 'https://kijimaru.jp/collections/fabric-type-flannel?sort_by=title-ascending';

  function normalizePath(path) {
    return String(path || '').replace(/\/+$/, '') || '/';
  }

  function targetWithPassthrough(sourceUrl) {
    var target = new URL(flannelTarget);
    sourceUrl.searchParams.forEach(function (value, key) {
      if (key === 'sort_by') return;
      if (!target.searchParams.has(key)) target.searchParams.append(key, value);
    });
    return target.pathname + '?' + target.searchParams.toString() + sourceUrl.hash;
  }

  function rewriteFlannelLinks(root) {
    var scope = root || document;
    var anchors = scope.querySelectorAll('a[href*="/collections/fabric-type-flannel"]');
    anchors.forEach(function (anchor) {
      var raw = anchor.getAttribute('href') || '';
      var url;
      try {
        url = new URL(raw, window.location.origin);
      } catch (error) {
        return;
      }
      if (normalizePath(url.pathname) !== flannelPath) return;
      if (url.searchParams.get('sort_by') === 'title-ascending') return;
      anchor.setAttribute('href', targetWithPassthrough(url));
    });
  }

  function redirectFlannelBase() {
    if (normalizePath(window.location.pathname) !== flannelPath) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('sort_by') === 'title-ascending') return;
    window.location.replace(targetWithPassthrough(new URL(window.location.href)));
  }

  redirectFlannelBase();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteFlannelLinks(document); }, { once: true });
  } else {
    rewriteFlannelLinks(document);
  }
  window.setTimeout(function () { rewriteFlannelLinks(document); }, 250);
  window.setTimeout(function () { rewriteFlannelLinks(document); }, 1200);
})();

/* Maruishi 2026-09-29: cards-carousel arrows when Judge.me navigation has not loaded. */
(function () {
  function moveCards(blockId, direction) {
    var root = Array.from(document.querySelectorAll('.jdgm-cards-carousel[data-jdgm-block-id]'))
      .find(function (node) { return node.getAttribute('data-jdgm-block-id') === blockId; });
    if (!root) return;
    var wrapper = root.querySelector('.jdgm-cards-wrapper');
    var cards = root.querySelectorAll('.jdgm-card');
    if (!wrapper || cards.length < 2) return;
    var step = Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
    var maximum = wrapper.scrollWidth - wrapper.clientWidth;
    if (step <= 0 || maximum <= 0) return;
    var current = wrapper.scrollLeft;
    var next = direction > 0
      ? (current >= maximum - 1 ? 0 : Math.min(maximum, current + step))
      : (current <= 1 ? maximum : Math.max(0, current - step));
    wrapper.scrollTo({ left: next, behavior: 'auto' });
  }
  // The vendor can replace these normally when its navigation bundle arrives.
  if (typeof window.jdgmNextCard !== 'function') {
    window.jdgmNextCard = function (blockId) { moveCards(blockId, 1); };
  }
  if (typeof window.jdgmPreviousCard !== 'function') {
    window.jdgmPreviousCard = function (blockId) { moveCards(blockId, -1); };
  }
})();

/* Maruishi Clarity purchase diagnostics v1 2026-09-29. No form values or customer data. */
(function () {
  if (window.__maruishiClarityFunnelV1) return;
  window.__maruishiClarityFunnelV1 = true;
  if (location.hostname !== 'kijimaru.jp' || window.Shopify?.designMode || window.Shopify?.previewMode || /(?:preview_theme_id|view_test|audit)=|[?&]view=[^&]*test/.test(location.search)) return;
  const match = location.pathname.match(/^\/products\/([a-zA-Z0-9_-]+)\/?$/);
  const handle = match ? match[1] : null;
  function send(name) {
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', 'mi_' + name);
      if (handle) window.clarity('event', 'mi_' + handle + '_' + name);
    } catch (_) { /* Analytics must never interrupt purchases. */ }
  }
  function listen(name, handler, capture) {
    document.addEventListener(name, function (event) { try { handler(event); } catch (_) {} }, capture);
  }
  const isAddForm = form => form?.matches?.('form[action*="/cart/add"]');
  if (handle) send('product_view');
  if (/^\/cart\/?$/.test(location.pathname)) send('cart_view');
  listen('variant:change', e => { if (isAddForm(e.target)) send('variant_resolved'); });
  listen('change', e => { if (e.target.matches?.('.product-info .qty-x50-select')) send('length_changed'); });
  listen('invalid', e => { if (isAddForm(e.target.form)) send('input_invalid'); }, true);
  listen('cart:error', e => { if (isAddForm(e.target)) send('purchase_message'); });
  listen('maruishi:cart-add-observed', e => {
    if (!isAddForm(e.target)) return;
    const phase = e.detail?.phase;
    if (['request','success','rejected','unknown'].includes(phase)) send('add_' + phase);
  });
  listen('submit', e => {
    if (/^\/cart\/?$/.test(location.pathname) && e.submitter?.name === 'checkout') send('checkout_submit_attempt');
  }, true);
})();
